export const resources = {
  uk: {
    translation: {
      common: {
        language: 'Мова',
        ukrainian: 'Українська',
        english: 'English',
        signOut: 'Вийти',
        appBarMenu: 'Меню',
        collapseSidebar: 'Згорнути бічну панель',
        expandSidebar: 'Розгорнути бічну панель',
        backToDashboard: 'Назад до панелі',
        system: 'Система',
        emptyTitle: 'Нічого не знайдено',
        emptyDescription: 'Спробуйте змінити фільтри або повернутися пізніше.',
        openProfile: 'Відкрити профіль',
      },
      dialog: {
        confirmTitle: 'Підтвердьте дію',
        confirm: 'Підтвердити',
        cancel: 'Скасувати',
        close: 'Закрити діалог',
        delete: 'Видалити',
        inputLabel: 'Коментар',
        required: 'Заповніть це поле',
      },
      nav: {
        dashboard: 'Панель',
        clients: 'Клієнти',
        chats: 'Чати',
        activity: 'Активність',
        testimonials: 'Відгуки',
        tasks: 'Завдання',
        bankAccounts: 'Банківські рахунки',
        pointsRewards: 'Бонусні винагороди',
        team: 'Команда',
        roles: 'Ролі',
        adminPanel: 'Адмін панель',
      },
      theme: {
        label: 'Тема',
        light: 'Світла',
        dark: 'Темна',
      },
      meshViewer: {
        title: '3D-модель',
        viewGroup: 'Режим',
        viewCurrent: 'Зараз',
        viewResult: 'Результат',
        viewOverlay: 'Накладення',
        jawGroup: 'Щелепа',
        jawUpper: 'Верхня',
        jawLower: 'Нижня',
        jawBoth: 'Обидві',
        presetGroup: 'Ракурс',
        presetFront: 'Спереду',
        presetLeft: 'Зліва',
        presetRight: 'Справа',
        presetTop: 'Зверху',
        presetBottom: 'Знизу',
        reset: 'Скинути камеру',
        stepGroup: 'Рух зубів',
        stepLabel: 'Крок {{index}}',
        stepPosition: '{{position}}/{{total}}',
        play: 'Відтворити',
        pause: 'Пауза',
        loading: 'Завантаження моделі…',
        empty: 'Немає моделей для перегляду',
        errorTitle: 'Не вдалося показати модель',
        errorUnsupported:
          'Цей браузер не підтримує 3D-перегляд. Спробуйте оновити його або відкрити на іншому пристрої.',
        errorDecode: 'Файл моделі пошкоджений або має непідтримуваний формат.',
        errorGeneric: 'Спробуйте оновити сторінку.',
      },
      testimonials: {
        title: 'Відгуки',
        subtitle:
          'Оцінки та коментарі пацієнтів за завершені етапи · {{count}}',
        stageN: '{{number}} етап',
        noComment: 'Без коментаря',
        viewProfile: 'Переглянути профіль пацієнта',
        emptyTitle: 'Поки що немає відгуків',
        emptyDescription:
          'Відгуки пацієнтів з’являться тут після завершення етапів.',
        loadErrorTitle: 'Не вдалося завантажити відгуки',
        loadErrorDescription: 'Спробуйте оновити сторінку пізніше.',
      },
      team: {
        title: 'Команда',
        subtitle: 'Адміністратори та запрошення',
      },
      tasks: {
        title: 'Завдання',
        create: 'Створити завдання',
        creating: 'Створення…',
        save: 'Зберегти',
        saving: 'Збереження…',
        cancel: 'Скасувати',
        edit: 'Редагувати',
        delete: 'Видалити',
        complete: 'Завершити',
        deadline: 'Дедлайн',
        priority: 'Пріоритет',
        status: 'Статус',
        assignees: 'Виконавці',
        relatedPatient: 'Пов’язаний пацієнт',
        relatedPatientPlaceholder: 'Виберіть пацієнта (необов’язково)',
        relatedPayment: 'Пов’язана оплата',
        noTasks: 'Завдань немає',
        noTasksDescription: 'Створіть нове завдання або зніміть фільтри.',
        noAdmins: 'Адміністраторів не знайдено',
        overdue: 'прострочено',
        mineOnly: 'Лише мої',
        search: 'Пошук',
        filterAny: 'Будь-який',
        confirmDelete: 'Видалити це завдання?',
        descriptionPlaceholder: 'Опис завдання (необов’язково)',
        titlePlaceholder: 'Назва завдання',
        labelTitle: 'Назва',
        labelDescription: 'Опис',
        newTaskTitle: 'Нове завдання',
        editTaskTitle: 'Редагування завдання',
        loadErrorTitle: 'Не вдалося завантажити завдання',
        loadErrorDescription: 'Спробуйте ще раз за мить.',
        statusLabels: {
          pending: 'Очікує',
          in_progress: 'В роботі',
          completed: 'Завершено',
          cancelled: 'Скасовано',
        },
        priorityLabels: {
          low: 'Низький',
          medium: 'Середній',
          high: 'Високий',
          urgent: 'Терміновий',
        },
        sourceLabels: {
          manual: 'Вручну',
          payment_verification: 'Перевірка оплати',
        },
      },
      patientPicker: {
        placeholder: 'Виберіть пацієнта',
        searchPlaceholder: 'Пошук пацієнта…',
        noResults: 'Пацієнтів не знайдено',
        loading: 'Завантаження…',
        clear: 'Очистити вибір',
      },
      notifications: {
        pageTitle: 'Сповіщення',
        bellTitle: 'Сповіщення',
        viewAll: 'Переглянути всі',
        noNew: 'Нових сповіщень немає',
        markRead: 'Позначити прочитаним',
        markUnread: 'Позначити непрочитаним',
        delete: 'Видалити',
        unread: 'Не прочитано',
        unreadOnly: 'Лише непрочитані',
        filterCategory: 'Категорія',
        filterAny: 'Будь-яка',
        empty: 'Сповіщень немає',
        loading: 'Завантаження…',
        confirmDelete: 'Видалити це сповіщення?',
        loadErrorTitle: 'Не вдалося завантажити сповіщення',
        loadErrorDescription: 'Спробуйте ще раз за мить.',
        loadMore: 'Завантажити ще',
        previous: 'Попередня',
        next: 'Наступна',
        justNow: 'щойно',
        minutesAgo: '{{count}} хв тому',
        hoursAgo: '{{count}} год тому',
        daysAgo: '{{count}} дн тому',
        categoryLabels: {
          patient_registered: 'Новий пацієнт',
          payment_submitted: 'Оплата надіслана',
          payment_overdue: 'Прострочена оплата',
          chat_unread: 'Непрочитане повідомлення',
          final_result_submitted: 'Фінальний фотопротокол',
        },
      },
      points: {
        balance: 'Баланс балів',
        balanceUnit: 'балів',
        balanceUah: '≈ {{amount}} {{currency}}',
        lifetimeGranted: 'Нараховано всього',
        lifetimeRedeemed: 'Списано всього',
        pricingHint:
          'Бали не змінюють ціну автоматично. Подивіться баланс, вирішіть розмір знижки, впишіть меншу суму в рахунок і спишіть бали тут.',
        grantTitle: 'Нарахувати бали',
        grantPoints: 'Скільки нарахувати',
        grantNote: 'Коментар до нарахування',
        grantNotePlaceholder: 'напр., привів друга Іваненко',
        grantCta: 'Нарахувати',
        granting: 'Нарахування…',
        redeemTitle: 'Списати бали',
        redeemReward: 'Винагорода',
        redeemFreeForm: 'Інше (вказати вручну)',
        redeemPoints: 'Скільки списати',
        redeemPointsOverrideHint: 'Залиште порожнім, щоб списати вартість винагороди',
        redeemNote: 'Коментар до списання',
        redeemCta: 'Списати',
        redeeming: 'Списання…',
        redeemInsufficient: 'Недостатньо балів на балансі.',
        reverseCta: 'Скасувати',
        confirmReverse:
          'Скасувати цю операцію? Буде додано зворотний запис, історія збережеться.',
        reversedBadge: 'скасовано',
        historyTitle: 'Історія',
        colDate: 'Дата',
        colDelta: 'Бали',
        colReason: 'Операція',
        colReward: 'Винагорода',
        colNote: 'Коментар',
        colAdmin: 'Адміністратор',
        emptyDescription: 'Операцій з балами ще не було.',
        loadErrorTitle: 'Не вдалося завантажити бали',
        loadErrorDescription: 'Спробуйте оновити сторінку.',
        reasonLabels: {
          manual_grant: 'Нарахування',
          redemption: 'Списання',
          reversal: 'Скасування',
        },
      },
      pointsRewards: {
        title: 'Бонусні винагороди',
        subtitle:
          'Каталог того, на що можна витратити бали. 1 бал = 1 грн. Неактивні винагороди приховані зі списку.',
        addReward: 'Додати винагороду',
        showInactive: 'Показати неактивні',
        hideInactive: 'Сховати неактивні',
        newRewardTitle: 'Нова винагорода',
        editRewardTitle: 'Редагувати винагороду',
        labelNameUk: 'Назва (укр.)',
        labelNameEn: 'Назва (англ.)',
        placeholderNameUk: 'Напр., Безкоштовний ретейнер',
        placeholderNameEn: 'e.g. Free retainer',
        labelPointCost: 'Вартість у балах',
        pointCostHint: '1 бал = 1 грн',
        labelRewardType: 'Тип',
        labelActive: 'Активна',
        costBadge: '{{count}} балів',
        inactiveBadge: 'неактивна',
        colNameEn: 'Англ.',
        colType: 'Тип',
        cancel: 'Скасувати',
        create: 'Створити',
        creating: 'Створення…',
        save: 'Зберегти',
        saving: 'Збереження…',
        edit: 'Редагувати',
        deactivate: 'Деактивувати',
        confirmDeactivate:
          'Деактивувати винагороду? Вона зникне зі списку вибору, а історія списань залишиться.',
        emptyTitle: 'Винагород ще немає',
        emptyDescription: 'Додайте першу винагороду, щоб адміністратори списували бали однаково.',
        loadErrorTitle: 'Не вдалося завантажити винагороди',
        loadErrorDescription: 'Спробуйте оновити сторінку.',
        rewardTypeLabels: {
          treatment_discount: 'Знижка на лікування',
          item: 'Товар або послуга',
        },
      },
      bankAccounts: {
        title: 'Банківські рахунки',
        subtitle:
          'Реквізити для оплат у мобільному застосунку. Неактивні рахунки приховані зі списку.',
        addAccount: 'Додати рахунок',
        cancel: 'Скасувати',
        create: 'Створити рахунок',
        creating: 'Створення…',
        save: 'Зберегти',
        saving: 'Збереження…',
        edit: 'Редагувати',
        deactivate: 'Деактивувати',
        confirmDeactivate:
          'Деактивувати цей рахунок? Його не буде видно при створенні оплат.',
        loadErrorTitle: 'Не вдалося завантажити рахунки',
        loadErrorDescription: 'Спробуйте ще раз за мить.',
        emptyTitle: 'Немає активних рахунків',
        emptyDescription: 'Додайте перший банківський рахунок.',
        colAccountName: 'Назва рахунку',
        colBank: 'Банк',
        colIban: 'IBAN',
        colSwift: 'SWIFT',
        colCurrency: 'Валюта',
        colAccountNumber: 'Номер рахунку',
        colPrivacyOffer: 'Публічна оферта',
        actions: 'Дії',
        newAccountTitle: 'Новий банківський рахунок',
        editAccountTitle: 'Редагування рахунку',
        labelAccountName: 'Назва рахунку',
        labelBankName: 'Назва банку',
        labelIban: 'IBAN',
        labelSwift: 'SWIFT (необов’язково)',
        labelAccountNumber: 'Номер рахунку (необов’язково)',
        labelCurrency: 'Валюта',
        labelPrivacyOffer: 'Публічна оферта (текст)',
        placeholderAccountName: 'наприклад, White&Flex UAH',
        placeholderBank: 'наприклад, ПриватБанк',
        placeholderIban: 'UA…',
        placeholderPrivacyOffer:
          'Текст публічної оферти, який побачить пацієнт перед оплатою.',
      },
      auth: {
        adminAccess: 'Доступ до адмінпанелі White&Flex',
        signInTitle: 'Увійдіть до CRM',
        signInDescription:
          'Безпечний доступ до операцій, координації лікування та внутрішніх процесів платформи White&Flex.',
        brandNoteDescription:
          'Градієнти залишаються атмосферними. Насичені робочі сценарії працюють на спокійних світлих поверхнях для контрасту й читабельності.',
        authentication: 'Автентифікація',
        welcomeBack: 'З поверненням',
        signInHint:
          'Скористайтеся початковими обліковими даними адміністратора або підключіть цей екран до живого сервісу авторизації.',
        signInError: 'Не вдалося увійти.',
        invalidCredentials: 'Невірні облікові дані.',
        adminOnly: 'Доступ до CRM дозволено лише адміністраторам.',
        tooManyAttempts: 'Забагато спроб. Спробуйте пізніше.',
        email: 'Електронна пошта',
        password: 'Пароль',
        signingIn: 'Вхід...',
        signIn: 'Увійти до панелі',
        accessRestricted:
          'Доступ дозволено лише автентифікованим адміністраторам White&Flex.',
        forgotPasswordLink: 'Забули пароль?',
        forgotPasswordTitle: 'Забули пароль?',
        forgotPasswordHint:
          'Якщо ця адреса належить обліковому запису адміністратора, ми надішлемо на неї 4-значний код і посилання для скидання пароля.',
        forgotPasswordSubmit: 'Надіслати код',
        sendingResetCode: 'Надсилання коду...',
        forgotPasswordError: 'Не вдалося надіслати код. Спробуйте ще раз.',
        resetPasswordTitle: 'Скидання пароля',
        resetPasswordHint: 'Введіть 4-значний код із листа та оберіть новий пароль.',
        resetPasswordCodeSent:
          'Якщо ця адреса належить обліковому запису адміністратора, на {{email}} надіслано 4-значний код і посилання для скидання. Введіть код та оберіть новий пароль.',
        resetPasswordInvalidLink: 'Посилання для скидання пароля недійсне.',
        resetPasswordError: 'Не вдалося скинути пароль. Перевірте код і спробуйте ще раз.',
        resetPasswordSuccess: 'Пароль змінено. Тепер ви можете увійти.',
        resetCode: 'Код підтвердження',
        newPassword: 'Новий пароль',
        confirmNewPassword: 'Підтвердьте новий пароль',
        resettingPassword: 'Зміна пароля...',
        resetPasswordSubmit: 'Змінити пароль',
        backToSignIn: 'Повернутися до входу',
        requestNewCode: 'Не отримали код? Надіслати новий',
      },
      dashboard: {
        greeting: 'З поверненням, {{name}}',
        justNow: 'Щойно',
        hoursAgo_one: '{{count}} годину тому',
        hoursAgo_few: '{{count}} години тому',
        hoursAgo_many: '{{count}} годин тому',
        daysAgo_one: '{{count}} день тому',
        daysAgo_few: '{{count}} дні тому',
        daysAgo_many: '{{count}} днів тому',
        totalPatients: 'Усього пацієнтів',
        activeTreatments: 'Активні лікування',
        pendingDeliveries: 'Очікують доставки',
        pendingPayments: 'Очікують оплати',
        recentActivity: 'Остання активність',
        quickActions: 'Швидкі дії',
        viewAllClients: 'Переглянути всіх клієнтів',
        addNewPatient: 'Додати пацієнта',
      },
      clients: {
        title: 'Клієнти',
        totalPatients_one: 'Усього {{count}} пацієнт',
        totalPatients_few: 'Усього {{count}} пацієнти',
        totalPatients_many: 'Усього {{count}} пацієнтів',
        addClient: 'Додати клієнта',
        searchPlaceholder: 'Пошук за ім’ям, поштою або ID...',
        searchGeneric: 'Пошук...',
        clearFilters: 'Скинути фільтри',
        filters: 'Фільтри',
        filterByAdmin: 'Призначені адміністратори',
        filterByStage: 'Етап',
        filterByStep: 'Крок',
        filterByAccountState: 'Стан акаунту',
        filterByUpdated: 'Діапазон дат оновлення',
        updatedFrom: 'Від',
        updatedTo: 'До',
        accountAny: 'Будь-який',
        accountPending: 'Очікує',
        accountActive: 'Активний',
        accountInactive: 'Неактивний',
        applyFilters: 'Застосувати',
        clearAllFilters: 'Скинути все',
        anyStage: 'Будь-який',
        adminTag: 'Адмін: {{value}}',
        stageTag: 'Стадія: {{value}}',
        stepTag: 'Етап: {{value}}',
        cycleTag: 'Стадія: {{value}}',
        accountTag: 'Акаунт: {{value}}',
        updatedFromTag: 'Оновлено від: {{value}}',
        updatedToTag: 'Оновлено до: {{value}}',
        searchTag: 'Пошук: {{value}}',
        statusTag: 'Статус: {{value}}',
        loadErrorTitle: 'Не вдалося завантажити клієнтів',
        loadErrorDescription: 'Спробуйте ще раз за мить.',
        emptyTitle: 'Клієнтів не знайдено',
        emptySearch: 'Спробуйте інший пошуковий запит.',
        emptyDefault: 'Додайте першого клієнта, щоб почати.',
        all: 'Усі',
        patient: 'Пацієнт',
        status: 'Статус',
        account: 'Акаунт',
        email: 'Електронна пошта',
        updated: 'Оновлено',
        actions: 'Дії',
        noClientId: 'Немає ID клієнта',
        pendingSignup: 'Очікує реєстрації',
        active: 'Активний',
        inactive: 'Неактивний',
        open: 'Відкрити',
        chat: 'Чат',
        scopeMine: 'Мої пацієнти',
        scopeAll: 'Усі пацієнти',
        assignedAdmins: 'Призначені',
        noAssignedAdmins: '—',
        emptyMineTitle: 'У вас ще немає призначених пацієнтів',
        emptyMineDescription:
          'Перемкніться на «Усі пацієнти», щоб побачити повний список.',
        rowsPerPage: 'Рядків на сторінку:',
        rangeOfTotal: '{{from}}-{{to}} з {{total}}',
        previousPage: 'Попередня сторінка',
        nextPage: 'Наступна сторінка',
        copied: 'Скопійовано',
        copyFailed: 'Не вдалося скопіювати — виберіть код вручну',
        inviteCodeReady: 'Код запрошення готовий',
        createClient: 'Створити клієнта',
        inviteCodeDescription:
          'Поділіться цим кодом з пацієнтом, щоб він завершив реєстрацію в мобільному застосунку.',
        createClientDescription:
          'У картці клініки ми зберігаємо лише ім’я. Пошту й пароль (або Google / Apple) пацієнт вибирає під час реєстрації.',
        closeCreateClientForm: 'Закрити форму створення клієнта',
        codeForPatient:
          'Код для {{name}} — дійсний, доки пацієнт не завершить реєстрацію.',
        copy: 'Скопіювати',
        close: 'Закрити',
        openClientRecord: 'Відкрити картку клієнта',
        firstName: 'Ім’я',
        lastName: 'Прізвище',
        cancel: 'Скасувати',
        creating: 'Створення...',
        createAndShowCode: 'Створити й показати код',
        delete: 'Видалити',
        deleteClientTitle: 'Видалити клієнта',
        deleteClientConfirm:
          'Видалити клієнта "{{name}}"? Цю дію не можна скасувати.',
        deleting: 'Видалення...',
        deleteFailed: 'Не вдалося видалити клієнта.',
        moreActions: 'Більше дій',
        viewTable: 'Таблиця',
        viewFunnel: 'Воронка',
        funnel: {
          stageGroup: 'Етап {{number}}',
          noCycle: 'Без етапу',
          emptyColumn: 'Немає пацієнтів',
          loadMore: 'Показати ще ({{count}})',
          loading: 'Завантаження...',
          moving: 'Переміщення...',
          moveConfirmTitle: 'Перемістити пацієнта',
          moveConfirmBody: 'Перемістити {{name}} до кроку «{{step}}»?',
          moveConfirmCta: 'Перемістити',
          moveError: 'Не вдалося перемістити пацієнта. Спробуйте ще раз.',
        },
      },
      stages: {
        preparing: 'Підготовка',
        modeling: 'Моделювання',
        payment: 'Оплата',
        manufacturing_delivery: 'Виробництво та доставка',
        wearing_aligners: 'Носіння елайнерів',
      },
      activity: {
        title: 'Активність',
        entries_one: '{{count}} запис',
        entries_few: '{{count}} записи',
        entries_many: '{{count}} записів',
        all: 'Усі',
        patient: 'Пацієнт',
        treatment: 'Лікування',
        stage: 'Етап',
        chat: 'Чат',
        assigned: 'Призначення',
        search: 'Пошук активності...',
        from: 'Від',
        to: 'До',
        clearFilters: 'Скинути фільтри',
        loadErrorTitle: 'Не вдалося завантажити активність',
        loadErrorDescription: 'Спробуйте ще раз за мить.',
        emptyTitle: 'Активність не знайдена',
        emptyFiltered: 'Спробуйте змінити фільтри.',
        emptyDefault:
          'Активність з’явиться тут, коли адміністратори виконуватимуть дії.',
        time: 'Час',
        admin: 'Адміністратор',
        action: 'Дія',
        patientColumn: 'Пацієнт',
        summary: 'Підсумок',
        rowsPerPage: 'Рядків на сторінку:',
        ofTotal: '{{from}}-{{to}} з {{total}}',
        previousPage: 'Попередня сторінка',
        nextPage: 'Наступна сторінка',
        actionLabels: {
          patient_created: 'Пацієнта створено',
          patient_updated: 'Пацієнта оновлено',
          treatment_created: 'Лікування створено',
          treatment_updated: 'Лікування оновлено',
          cycle_created: 'Етап створено',
          cycle_updated: 'Етап оновлено',
          stage_updated: 'Етап оновлено',
          payment_confirmed: 'Оплату підтверджено',
          payment_rejected: 'Оплату відхилено',
          delivery_updated: 'Доставку оновлено',
          chat_assigned: 'Чат призначено',
          chat_message_sent: 'Повідомлення чату',
        },
      },
      error: {
        notFound: 'Цього маршруту немає в поточній CRM-оболонці.',
        forbidden: 'У вас немає дозволу на доступ до цієї сторінки.',
      },
      status: {
        draft: 'Чернетка',
        active: 'Активний',
        completed: 'Завершений',
        cancelled: 'Скасований',
        not_started: 'Не розпочато',
        in_progress: 'У процесі',
        blocked: 'Заблокований',
        pending: 'Очікує',
        preparing_shipment: 'Підготовка до відправки',
        shipped: 'Відправлено',
        delivered: 'Доставлено',
        submitted_by_patient: 'Надіслано пацієнтом',
        confirmed: 'Підтверджено',
        rejected: 'Відхилено',
        verified: 'Перевірено',
      },
      clientDetail: {
        clientStatus: {
          title: 'Статус клієнта',
          subtitle: 'Коротка перевірка готовності. Підказки не блокують роботу.',
          countsLabel: 'Підсумок готовності клієнта',
          doneTitle: 'Виконано',
          todoTitle: 'Потребує уваги',
          doneLabel: 'Готово:',
          todoLabel: 'Далі:',
          doneCount: 'Виконано: {{count}}',
          todoCount: 'Залишилось: {{count}}',
          loading: 'Перевіряємо статус клієнта…',
          unavailable: 'Не вдалося перевірити статус лікування.',
          noneDone: 'Ще немає виконаних пунктів.',
          nothingLeft: 'На цьому етапі все готово.',
          items: {
            spacingMapReady: 'карту міжзубних проміжків завантажено.',
            spacingMapMissing: 'завантажте карту міжзубних проміжків.',
            activeTreatmentReady: 'активне лікування створено.',
            activeTreatmentMissing: 'створіть або активуйте лікування.',
            diagnosisReady: 'діагноз заповнено.',
            diagnosisMissing: 'додайте діагноз до активного лікування.',
            activeCycleReady: 'етап {{number}} активний.',
            activeCycleMissing: 'створіть або активуйте етап лікування.',
            completedStage: 'крок «{{stage}}» завершено.',
            blockedStage: 'крок «{{stage}}» заблоковано — перевірте причину.',
            currentStage: 'зараз триває крок «{{stage}}».',
            requiredProcedureReady: 'обов’язкову процедуру «{{title}}» перевірено.',
            requiredProcedureNeedsVerification: 'перевірте виконання процедури «{{title}}».',
            requiredProcedurePending: 'завершіть обов’язкову процедуру «{{title}}».',
            requiredProceduresMissing: 'налаштуйте обов’язкові процедури підготовки.',
            modelingPlanReady: 'план лікування створено.',
            modelingPlanMissing: 'створіть план лікування.',
            publishedPlanReady: 'готовий план опубліковано для пацієнта.',
            publishedPlanMissing: 'опублікуйте готовий план із кількістю елайнерів.',
            planApprovedByPatient: 'пацієнт погодив план лікування.',
            planPendingPatientApproval: 'пацієнт ще не погодив план лікування.',
            paymentStageCurrent: 'поточний крок — оплата; перевірте його стан.',
            deliveryReady: 'доставку створено.',
            deliveryMissing: 'створіть доставку для цього етапу.',
            trackingReady: 'номер відстеження додано.',
            trackingMissing: 'додайте номер відстеження перед відправленням.',
            deliveryShipped: 'замовлення відправлено.',
            deliveryDelivered: 'замовлення доставлено.',
            deliveryCancelled: 'доставку скасовано — створіть або налаштуйте її повторно.',
            alignerSetsReady: 'комплекти елайнерів створено: {{actual}} із {{expected}}.',
            alignerSetsMissing: 'створіть усі комплекти елайнерів: {{actual}} із {{expected}}.',
            wearingStarted: 'носіння елайнерів розпочато.',
            wearingNotStarted: 'зафіксуйте початок носіння елайнерів.',
          },
        },
        unableToLoadPatient: 'Не вдалося завантажити пацієнта',
        tryAgain: 'Спробуйте ще раз за мить.',
        backToClients: 'Назад до клієнтів',
        patientNotFound: 'Пацієнта не знайдено',
        hideTreatmentForm: 'Сховати форму',
        addTreatment: 'Додати лікування',
        hideNotifications: 'Сховати сповіщення',
        showNotifications: 'Показати сповіщення',
        openChat: 'Відкрити чат',
        workspaceNavigation: 'Розділи картки пацієнта',
        treatments: 'Лікування',
        treatmentsSubtitle:
          'Керуйте зведенням лікування, клінічними посиланнями, налаштуванням етапів та прогресом кроків тут.',
        unableToLoadTreatments: 'Не вдалося завантажити лікування.',
        noTreatmentsYet: 'Немає лікувань.',
        noTreatmentsHint:
          'Створіть перше лікування, щоб почати відстеження етапів і кроків для цього пацієнта.',
        newTreatment: 'Нове лікування',
        newTreatmentHint:
          'Спочатку створіть зведення лікування, а потім додайте етапи та оновіть кроки нижче.',
        creatingTreatment: 'Створення лікування...',
        createTreatment: 'Створити лікування',
        untitledTreatment: 'Без назви',
        deleteTreatmentConfirm:
          'Видалити лікування "{{name}}"? Цю дію не можна скасувати.',
        deleteTreatmentTitle: 'Видалити лікування',
        savingTreatment: 'Збереження лікування...',
        saveTreatmentSummary: 'Зберегти зведення лікування',
        stages: 'Етапи',
        stageN: 'Етап {{number}}',
        stagesCount_one: '{{count}} етап',
        stagesCount_few: '{{count}} етапи',
        stagesCount_many: '{{count}} етапів',
        stageSelectorLabel: 'Вибір етапу',
        correctionN: 'Корекція {{number}}',
        renameStage: 'Змінити назву етапу',
        renameStageLabel: 'Назва етапу для пацієнта',
        cancelStageRename: 'Скасувати зміну назви',
        stageLabelKind: {
          stage: 'Етап',
          correction: 'Корекція',
        },
        addingStage: 'Додавання...',
        addStage: 'Додати етап',
        addStageBlockedByInProgress: 'Спочатку завершіть поточний етап',
        deleteStageTitle: 'Видалити етап',
        deleteStageLabel: 'Видалити {{label}}',
        deleteStageConfirm:
          'Видалити «{{label}}» разом з усіма його даними? Цю дію не можна скасувати.',
        deletingStage: 'Видалення...',
        noStagesYet:
          'Немає етапів. Додайте перший етап, щоб розблокувати керування кроками.',
        treatmentStatus: 'Статус',
        diagnosisTitle: 'Назва діагнозу',
        diagnoses: 'Діагнози',
        addDiagnosis: 'Додати діагноз',
        removeDiagnosis: 'Видалити діагноз',
        patientFeatures: 'Особливості пацієнта',
        patientFeaturePlaceholder: 'Опишіть особливість',
        addPatientFeature: 'Додати особливість',
        removePatientFeature: 'Видалити особливість',
        recommendationLetter: 'Рекомендаційний лист',
        recommendationLetterUploadCta: 'Завантажити рекомендаційний лист',
        recommendationLetterReplaceCta: 'Замінити',
        recommendationLetterDeleteCta: 'Видалити',
        recommendationLetterDeleteConfirm:
          'Видалити рекомендаційний лист? Цю дію не можна скасувати.',
        recommendationLetterInvalidType:
          'Непідтримуваний тип файлу. Завантажте JPEG, PNG або WebP.',
        recommendationLetterTooLarge: 'Файл перевищує ліміт розміру 10 МБ.',
        recommendationLetterPreviewLoadFailed:
          'Не вдалося завантажити зображення.',
        recommendationLetterUploading: 'Завантаження...',
        recommendationLetterDeleting: 'Видалення...',
        toothSpacingMap: 'Карта міжзубних проміжків',
        requiredBadge: 'Обов’язково',
        toothSpacingMapMissingTitle: 'Карту ще не додано',
        toothSpacingMapMissingHint: 'Додайте JPEG, PNG або WebP до 10 МБ.',
        toothSpacingMapUploadCta: 'Завантажити карту',
        toothSpacingMapReplaceCta: 'Замінити карту',
        toothSpacingMapDeleteCta: 'Видалити карту',
        toothSpacingMapDeleteConfirm:
          'Видалити карту міжзубних проміжків? Цю дію не можна скасувати.',
        toothSpacingMapInvalidType:
          'Непідтримуваний тип файлу. Завантажте JPEG, PNG або WebP.',
        toothSpacingMapTooLarge: 'Файл перевищує ліміт розміру 10 МБ.',
        toothSpacingMapUploading: 'Завантаження...',
        toothSpacingMapDeleting: 'Видалення...',
        toothSpacingMapPreviewLoadFailed: 'Не вдалося завантажити зображення.',
        currentStageKind: 'Поточний етап',
        patientStageTitle: 'Назва для пацієнта',
        patientStageTitlePlaceholder: "Необов'язкова назва для пацієнта",
        upperAligners: 'Верхні елайнери',
        lowerAligners: 'Нижні елайнери',
        createdAt: 'Створено {{datetime}}',
        sectionTreatmentsSubtitle: 'Діагноз, етапи, кроки',
        sectionTreatmentData: 'Дані лікування',
        sectionTreatmentDataSubtitle: 'Статус, діагнози, особливості пацієнта та рекомендаційні листи',
        sectionPhotoControl: 'Фотоконтроль',
        sectionPhotoControlSubtitle: 'Розклад та перегляд фото пацієнта',
        photoControl: {
          triggerSource: {
            wearingStageEntry: 'Авто · початок носіння',
          },
          schedule: {
            title: 'Розклад фотоконтролю',
            subtitle: 'Автоматичні нагадування пацієнту про фото та відео',
            newSubtitle: 'Налаштуйте частоту та необхідні матеріали',
            requiredPhotos: 'Необхідні фото',
            selectPhoto: 'Оберіть щонайменше одне фото',
            requireVideo: 'Вимагати відео',
          },
          review: {
            title: 'Записи фотоконтролю',
            subtitle: 'Перевірте матеріали пацієнта та залиште рекомендації',
            photoCount_one: '{{count}} фото',
            photoCount_few: '{{count}} фото',
            photoCount_many: '{{count}} фото',
            doctorComment: 'Коментар лікаря',
            noComment: 'Коментар не додано',
            saveFailed: 'Не вдалося зберегти зміни',
            viewVideo: 'Перегляд відео',
            closeVideo: 'Закрити відео',
            viewPhotos: 'Перегляд фотографій',
            closePhotos: 'Закрити перегляд',
            previousPhoto: 'Попереднє фото',
            nextPhoto: 'Наступне фото',
          },
        },
        sectionToothSpacing: 'Процедура сепарація',
        sectionToothSpacingSubtitle: 'Розклад та записи шліфування',
        toothSpacing: {
          schedule: {
            title: 'Розклад процедури сепарації',
            subtitle: 'Регулярні завдання та нагадування для пацієнта',
            newSubtitle: 'Налаштуйте частоту виконання процедури',
          },
          review: {
            title: 'Записи сепарації зубів',
            subtitle: 'Історія виконання процедур та матеріали пацієнта',
          },
          entries: {
            title: 'Записи сепарації зубів',
            subtitle: 'Швидкий огляд стану запланованих процедур',
          },
        },
        toothSpacingUi: {
          everyNDays: 'Кожні {{days}} днів',
          filterByStatus: 'Фільтр записів за статусом',
          loadingEntries: 'Завантаження записів',
          loadEntriesFailed: 'Не вдалося завантажити записи',
          emptyEntries: 'Записів не знайдено',
          loadingDetails: 'Завантаження...',
          loadDetailsFailed: 'Не вдалося завантажити деталі',
          stageN: 'Етап {{number}}',
          confirmedAt: 'Підтверджено {{datetime}}',
          status: {
            all: 'Усі',
            pending: 'Очікує',
            confirmed: 'Виконано',
            active: 'Активний',
            inactive: 'Неактивний',
          },
          schedule: {
            title: 'Розклад процедури сепарації',
            subtitle: 'Регулярні завдання та нагадування для пацієнта',
            treatment: 'Лікування',
            loading: 'Завантаження розкладів',
            loadFailed: 'Не вдалося завантажити розклади',
            noEndDate: 'без дати завершення',
            deactivate: 'Деактивувати',
            empty: 'Розклади не налаштовано',
            newTitle: 'Новий розклад',
            newSubtitle: 'Налаштуйте частоту виконання процедури',
            interval: 'Інтервал',
            startDate: 'Дата початку',
            endMode: 'Завершення',
            endByDate: 'За датою',
            endByRepetitions: 'За кількістю повторень',
            endDateOptional: 'Дата завершення (необов’язково)',
            datePlaceholder: 'дд.мм.рррр',
            repetitions: 'Кількість повторень',
            creating: 'Створення...',
            create: 'Створити розклад',
            createFailed: 'Не вдалося створити розклад. Спробуйте ще раз.',
          },
          entries: {
            title: 'Записи сепарації зубів',
            subtitle: 'Швидкий огляд стану запланованих процедур',
          },
          review: {
            title: 'Записи сепарації зубів',
            subtitle: 'Історія виконання процедур та матеріали пацієнта',
            video: 'Відео',
            videoNotSubmitted: 'Відео ще не надіслано',
            description: 'Опис',
            noDescription: 'Опис не додано',
          },
        },
        monitoring: {
          filterByStatus: 'Фільтр записів за статусом',
          loadingEntries: 'Завантаження записів',
          loadEntriesFailed: 'Не вдалося завантажити записи',
          loadDetailsFailed: 'Не вдалося завантажити деталі',
          stageN: 'Етап {{number}}',
          confirmedAt: 'Підтверджено {{datetime}}',
          schedule: {
            loading: 'Завантаження розкладів',
            loadFailed: 'Не вдалося завантажити розклади',
            active: 'Активний',
            inactive: 'Неактивний',
            noEndDate: 'без дати завершення',
            newTitle: 'Новий розклад',
            interval: 'Інтервал',
            startDate: 'Дата початку',
            endMode: 'Завершення',
            endByDate: 'За датою',
            endByRepetitions: 'За кількістю повторень',
            endDateOptional: 'Дата завершення (необов’язково)',
            datePlaceholder: 'дд.мм.рррр',
            repetitions: 'Кількість повторень',
            creating: 'Створення...',
            create: 'Створити розклад',
            createFailed: 'Не вдалося створити розклад. Спробуйте ще раз.',
          },
        },
        sectionAssignedAdmins: 'Призначені адміністратори',
        sectionAssignedAdminsSubtitle:
          'Хто з команди відповідає за цього пацієнта',
        sectionPayments: 'Оплати',
        sectionPaymentsSubtitle:
          'Виставляйте рахунки та керуйте оплатами клієнта',
        sectionPoints: 'Бонусні бали',
        sectionPointsSubtitle:
          'Нарахування та списання балів клієнта',
        issueInvoice: 'Виставити рахунок',
        noPaymentsYet: 'Поки немає жодної оплати.',
        payments: {
          errorActiveCycle:
            'У пацієнта має бути рівно один активний етап лікування для виставлення рахунку.',
          errorExisting: 'Існує непідтверджена оплата для цього пацієнта.',
          confirmCta: 'Підтвердити',
          rejectCta: 'Відхилити',
          rejectReasonPrompt: 'Вкажіть причину відхилення',
          cycleAutoSwitchHint:
            'Створення оплати автоматично переведе активний етап у статус «Оплата». Після підтвердження етап повернеться до попереднього етапу.',
          pointsBalanceHint:
            'У клієнта {{points}} бонусних балів ({{amount}} {{currency}}). Врахуйте знижку в сумі рахунку вручну та спишіть бали у вкладці «Бонусні бали».',
          title: 'Назва рахунку',
          titlePlaceholder: 'Напр., Передоплата за лікування',
          untitledInvoice: 'Рахунок без назви',
          bankAccount: 'Банківський рахунок',
          paymentMethod: 'Спосіб оплати',
          paymentMethodBank: 'Банківський рахунок',
          paymentMethodLink: 'Посилання для оплати',
          paymentMethodInvoicePdf: 'Оплата по PDF рахунку',
          invoicePdfMethodHint:
            'Реквізити не потрібні — пацієнт сплачує за прикріпленим PDF рахунком.',
          invoicePdfMethodNeedsFile:
            'Спочатку завантажте PDF рахунок у картці оплати, потім змініть спосіб оплати.',
          invoiceFilePdf: 'PDF рахунок',
          invoiceFilePdfHint: 'Лише PDF, до 15 МБ. Обов’язково для цього способу оплати.',
          invoicePdfRequired: 'Прикріпіть PDF рахунок, щоб створити оплату.',
          invoicePdfOnly: 'Для оплати по PDF рахунку прикріпіть файл у форматі PDF.',
          paymentLink: 'Посилання для оплати',
          paymentLinkPlaceholder: 'https://...',
          paymentLinkRequired: 'Введіть посилання',
          openPaymentLink: 'Відкрити посилання',
          amount: 'Сума',
          currency: 'Валюта',
          deadline: 'Термін оплати',
          createdAt: 'Створено',
          rejectionReason: 'Причина відхилення',
          selectBank: 'Оберіть рахунок…',
          loading: 'Завантаження…',
          create: 'Створити оплату',
          creating: 'Створення…',
          recordPrepayment: 'Записати передоплату',
          markPaidLabel: 'Записати як уже сплачено (передоплата)',
          markPaidHint:
            'Використовуйте, якщо пацієнт сплатив поза системою. Не змінює етап етапу.',
          cancel: 'Скасувати',
          edit: 'Редагувати',
          saveEdit: 'Зберегти зміни',
          invoiceFile: 'Файл рахунку',
          invoiceFileHint: 'PDF, Word або Excel, до 15 МБ. Необов’язково.',
          invoiceDropHint:
            'Перетягніть файл сюди, вставте з буфера (Ctrl+V) або натисніть, щоб обрати',
          invoiceNoFile: 'Файл не обрано',
          invoiceRemoveFile: 'Прибрати файл',
          uploadInvoice: 'Завантажити файл рахунку',
          replaceInvoice: 'Замінити рахунок',
          deleteInvoice: 'Видалити рахунок',
          viewInvoice: 'Переглянути рахунок',
          invoiceWrongType: 'Будь ласка, завантажте PDF, Word або Excel.',
          invoiceTooLarge: 'Файл перевищує ліміт 15 МБ.',
          invoiceDeleteConfirm: 'Видалити файл рахунку?',
          uploadAfterCreateFailed:
            'Оплату створено, але файл не завантажено. Додайте його з картки оплати.',
          deletePayment: 'Видалити рахунок',
          deletePaymentConfirm:
            'Видалити цей рахунок? Цю дію не можна скасувати.',
          genericError: 'Не вдалося виконати дію. Спробуйте ще раз.',
        },
        assignedAdminsNone: 'Ще не призначено жодного адміністратора.',
        assignedAdminsManage: 'Керувати командою',
        assignedAdminsClose: 'Закрити',
        assignedAdminsSave: 'Зберегти',
        assignedAdminsCancel: 'Скасувати',
        assignedAdminsSaving: 'Збереження...',
        assignedAdminsSaveError: 'Не вдалося зберегти призначення.',
        assignedAdminsRosterError: 'Не вдалося завантажити адміністраторів.',
        assignedAdminsRosterLoading: 'Завантаження адміністраторів…',
        toggleTreatment: 'Розгорнути або згорнути розділ',
        toggleStages: 'Розгорнути або згорнути етапи',
      },
      roles: {
        title: 'Ролі та дозволи',
        subtitle: 'Керування доступом',
        rolesTab: 'Ролі',
        usersTab: 'Користувачі',
        adminsTab: 'Адміністратори',
        unableToLoadRoles: 'Не вдалося завантажити ролі',
        createRoleBtn: 'Створити роль',
        noRolesFound: 'Ролі не знайдено',
        noRolesDescription: 'Створіть першу роль, щоб почати.',
        colName: 'Назва',
        colDescription: 'Опис',
        colPermissions: 'Дозволи',
        colType: 'Тип',
        colActions: 'Дії',
        permissionsCount: '{{count}} дозволів',
        systemType: 'Системна',
        customType: 'Власна',
        editBtn: 'Редагувати',
        deleteBtn: 'Видалити',
        deleteRoleConfirm: 'Видалити роль "{{name}}"?',
        editRoleTitle: 'Редагування ролі: {{name}}',
        createRoleTitle: 'Створити роль',
        createRoleDescription: 'Визначте нову роль із конкретними дозволами.',
        editRoleDescription: 'Змініть налаштування ролі та дозволи.',
        labelName: 'Назва',
        labelDescription: 'Опис',
        labelPermissions: 'Дозволи',
        cancel: 'Скасувати',
        close: 'Закрити',
        saving: 'Збереження...',
        create: 'Створити',
        save: 'Зберегти',
        unableToLoadUsers: 'Не вдалося завантажити користувачів',
        noUsersFound: 'Користувачів не знайдено',
        noUsersDescription: "Користувачі з'являться тут після створення.",
        colEmail: 'Електронна пошта',
        colRoles: 'Ролі',
        noRolesAssigned: 'Без ролей',
        assign: 'Призначити',
        assignRolesTitle: 'Призначити ролі',
        assignRolesSubtitle: 'Оберіть ролі для {{name}}',
        inviteAdminBtn: 'Запросити адміністратора',
        inviteAdminTitle: 'Запросити адміністратора',
        inviteAdminDescription:
          'Надішліть email-запрошення. Користувач отримає 4-значний код для активації облікового запису.',
        editAdminTitle: 'Редагувати адміністратора',
        editAdminDescription: "Оновіть ім'я та призначені ролі.",
        deleteAdminConfirm:
          'Видалити адміністратора "{{name}}"? Цю дію не можна скасувати.',
        labelFirstName: "Ім'я",
        labelLastName: 'Прізвище',
        labelEmail: 'Електронна пошта',
        labelFullName: "Повне ім'я",
        inviteSentMessage:
          'Запрошення надіслано. Користувач отримає лист з кодом.',
        invite: 'Запросити',
        acceptInviteTitle: 'Прийняти запрошення',
        acceptInviteSubtitle:
          'Введіть код із листа та оберіть пароль для входу.',
        acceptInviteCode: 'Код підтвердження',
        acceptInvitePassword: 'Новий пароль',
        acceptInvitePasswordConfirm: 'Підтвердьте пароль',
        acceptInviteSubmit: 'Активувати акаунт',
        acceptInviteSuccess: 'Акаунт активовано. Перенаправлення…',
        acceptInviteError:
          'Не вдалося прийняти запрошення. Перевірте код і спробуйте ще раз.',
        passwordMismatch: 'Паролі не співпадають.',
        resetPasswordBtn: 'Скинути пароль',
        resetPasswordTitle: 'Надіслати скидання пароля?',
        resetPasswordConfirm:
          'Надіслати {{name}} лист для скидання пароля на адресу {{email}}?',
        resetPasswordSending: 'Надсилання...',
        resetPasswordSent: 'Лист для скидання пароля надіслано на {{email}}.',
        resetPasswordError: 'Не вдалося надіслати лист для скидання пароля.',
      },
      helpArticles: {
        forbidden: 'Доступ заборонено',
        forbiddenDescription:
          'У вас немає дозволу на управління довідковими статтями.',
        title: 'Блог',
        subtitleCount_one: '{{count}} стаття в бібліотеці',
        subtitleCount_few: '{{count}} статті в бібліотеці',
        subtitleCount_many: '{{count}} статей у бібліотеці',
        newArticle: 'Нова стаття',
        mobileAppPreview: 'Перегляд у мобільному',
        mobileAppPreviewTitle: 'Перегляд блогу в мобільному застосунку',
        mobileAppPreviewListHint:
          'Список показує лише опубліковані статті — так само, як для пацієнта.',
        mobileAppPreviewDraftHint:
          'Попередній перегляд враховує незбережені зміни в редакторі.',
        closeMobileAppPreview: 'Закрити перегляд',
        previewArticle: 'Переглянути статтю',
        untitledPreview: 'Без назви',
        searchPlaceholder: 'Пошук статей...',
        library: 'Бібліотека',
        itemsCount: '{{count}} елементів',
        loadingArticles: 'Завантаження статей…',
        unableToLoad: 'Не вдалося завантажити статті',
        tryAgain: 'Спробуйте ще раз за мить.',
        noArticlesFound: 'Статей не знайдено',
        noArticlesDescription: 'Налаштуйте пошук або створіть першу статтю.',
        orderLabel: 'Порядок {{order}}',
        createArticle: 'Створити статтю',
        selectArticle: 'Оберіть статтю',
        draftHint: 'Чернетки приховані в мобільному до публікації.',
        moveToDraft: 'Перенести в чернетки',
        publish: 'Опублікувати',
        noArticleSelected: 'Статтю не обрано',
        noArticleSelectedDescription:
          'Оберіть статтю з бібліотеки або створіть нову.',
        titleLabel: 'Заголовок',
        summaryLabel: 'Короткий опис',
        sortOrderLabel: 'Порядок сортування',
        mobilePreviewTitle: 'Попередній перегляд картки в мобільному застосунку',
        mobilePreviewDescription:
          'Налаштуйте окреме зображення та його кадрування для картки статті в мобільному застосунку.',
        mobilePreviewAlt: 'Попередній перегляд картки статті',
        mobilePreviewEmpty: 'Додайте зображення обкладинки або окреме зображення для картки.',
        mobilePreviewLoadError: 'Не вдалося завантажити або відобразити зображення.',
        previewDedicatedHint: 'Мобільний застосунок використовуватиме окреме зображення.',
        previewHeroFallbackHint:
          'Окремого зображення немає. Мобільний застосунок використає зображення обкладинки.',
        previewNoFallbackHint:
          'Окремого зображення та зображення обкладинки немає. Картка буде без зображення.',
        uploadPreviewImage: 'Завантажити зображення для картки',
        replacePreviewImage: 'Замінити зображення для картки',
        removePreviewImage: 'Видалити зображення для картки',
        previewImageFormats:
          'JPEG, PNG або WebP · максимум 10 МБ · до 2048 пікселів з кожного боку та до 4 МП.',
        previewFitLabel: 'Заповнення рамки',
        previewFitCover: 'Обрізати до рамки',
        previewFitContain: 'Вмістити повністю',
        previewPositionX: 'Горизонтальна позиція',
        previewPositionY: 'Вертикальна позиція',
        heroImage: 'Зображення обкладинки',
        imageUploaded: 'Зображення завантажено',
        noImageUploaded: 'Зображення ще не завантажено',
        uploadImage: 'Завантажити зображення',
        heroImagePendingHint:
          'Завантажиться на сервер після збереження чернетки.',
        clearPendingHero: 'Прибрати файл',
        mediaTabImage: 'Зображення',
        mediaTabVideo: 'Відео',
        mediaTabYoutube: 'YouTube',
        uploadVideo: 'Завантажити відео',
        videoUploaded: 'Відео завантажено',
        noVideoUploaded: 'Відео ще не завантажено',
        videoPendingHint: 'Відео завантажиться після створення чернетки.',
        clearPendingVideo: 'Видалити очікуване відео',
        mediaTabPdf: 'PDF',
        heroPdf: 'PDF-документ',
        uploadPdf: 'Завантажити PDF',
        pdfUploaded:
          'PDF завантажено (мобільні бачитимуть першу сторінку як обкладинку)',
        noPdfUploaded: 'PDF ще не завантажено',
        pdfPendingHint: 'PDF завантажиться після створення чернетки.',
        clearPendingPdf: 'Видалити очікуваний PDF',
        uploadingPdf: 'Завантаження PDF…',
        pdfRequirements: 'Лише PDF · максимум {{maxMb}} МБ.',
        pdfTooLarge: 'PDF не може перевищувати {{maxMb}} МБ. Стисніть файл і спробуйте ще раз.',
        pdfPreviewLabel: 'Перегляд PDF',
        pdfPreviewError: 'Не вдалося завантажити PDF',
        youtubeUrlLabel: 'Посилання на YouTube',
        youtubeUrlPlaceholder: 'https://youtube.com/watch?v=...',
        invalidYoutubeUrl: 'Некоректне посилання YouTube.',
        saveYoutube: 'Зберегти посилання YouTube',
        youtubePosterAuto: 'Обкладинку отримано з YouTube.',
        removeMedia: 'Видалити медіа',
        sections: 'Секції',
        addSection: 'Додати секцію',
        sectionHeading: 'Заголовок',
        sectionBody: 'Текст',
        removeSection: 'Видалити секцію',
        saveChanges: 'Зберегти зміни',
        createDraft: 'Створити чернетку',
        deleteArticle: 'Видалити статтю',
        deleteArticleConfirm: 'Видалити статтю «{{title}}»? Цю дію не можна скасувати.',
        statusPublished: 'опубліковано',
        statusDraft: 'чернетка',
      },
      chats: {
        inbox: 'Вхідні',
        assignedChats: 'Призначені чати',
        chatActions: 'Дії з чатом {{name}}',
        markUnread: 'Позначити непрочитаним',
        searchPlaceholder: 'Пошук пацієнта чи адміністратора',
        searchMessages: 'Пошук у листуванні',
        searchMessagesTitle: 'Шукати в повідомленнях',
        searchNoResults: 'Нічого не знайдено',
        searchPrev: 'Попередній збіг',
        searchNext: 'Наступний збіг',
        closeSearch: 'Закрити пошук',
        jumpToLatest: 'До останніх повідомлень',
        jumpToDate: 'Перейти до дати',
        selectDate: 'Виберіть дату',
        today: 'Сьогодні',
        yesterday: 'Вчора',
        unlabelledPatient: 'Пацієнт без ID',
        selectChat: 'Оберіть чат, щоб відкрити розмову.',
        loadingConversation: 'Завантаження розмови…',
        noConversation: 'Для цього пацієнта немає розмови.',
        patientThread: 'Гілка пацієнта',
        noPatientId: 'Немає ID пацієнта',
        assignedAdminsCount: '{{count}} призначених адміністраторів',
        openPatientProfile: 'Відкрити профіль пацієнта',
        patientProfileTitle: 'Профіль пацієнта',
        closeTeamAssignment: 'Закрити призначення команди',
        manageAssignedTeam: 'Керувати призначеною командою',
        backToList: 'Назад до списку',
        close: 'Закрити',
        manageTeam: 'Керувати командою',
        assignedAdminsTitle: 'Призначені адміністратори',
        available: 'Доступний',
        offline: 'Не в мережі',
        cancel: 'Скасувати',
        saveAssignments: 'Зберегти призначення',
        fileAttachmentReady: 'Файл готовий до відправки',
        discardAttachment: 'Видалити вкладення',
        sendFile: 'Надіслати файл',
        discard: 'Видалити',
        send: 'Надіслати',
        recordingVoice: 'Запис голосового повідомлення · {{time}}',
        messagePlaceholder: 'Повідомлення',
        attachFile: 'Прикріпити файл',
        dropFileHere: 'Відпустіть файл, щоб прикріпити',
        stopRecording: 'Зупинити запис',
        sendMessage: 'Надіслати повідомлення',
        chooseEmoji: 'Вибрати емодзі',
        insertEmoji: 'Вставити емодзі',
        reactToMessage: 'Відреагувати на повідомлення',
        chooseReaction: 'Вибрати реакцію',
        reactWith: 'Відреагувати',
        addReaction: 'Додати реакцію',
        removeReaction: 'Прибрати реакцію',
        reactionFailed: 'Не вдалося оновити реакцію. Спробуйте ще раз.',
        recordVoice: 'Записати голосове повідомлення',
        voiceMessage: 'Голосове повідомлення',
        deleteVoiceMessage: 'Видалити голосове повідомлення',
        pausePreview: 'Пауза',
        playPreview: 'Відтворити',
        sendVoiceMessage: 'Надіслати голосове повідомлення',
        micNotAvailable: 'Запис мікрофону недоступний у цьому браузері.',
        noAudioCaptured: 'Аудіо не записано.',
        recordingStopped: 'Запис зупинився несподівано.',
        micPermissionDenied: 'Дозвіл на мікрофон відхилено або недоступний.',
        voicePlaybackRequiresSession:
          'Для відтворення потрібна активна сесія адміністратора.',
        voicePlaybackUnavailable:
          'Відтворення голосового повідомлення недоступне.',
        voiceLoading: 'Завантаження…',
        demoVoiceMock: 'Демо — тестовий режим',
        voiceMessageFallback: 'Голосове повідомлення',
        fileAttachmentFallback: 'Файлове вкладення',
        mockFileAttachment: 'Тестовий файл.',
        fileDownloadUnavailable: 'Завантаження файлу недоступне.',
        unknownFileType: 'Невідомий тип файлу',
        downloading: 'Завантаження',
        downloadFile: 'Завантажити файл',
        downloadingEllipsis: 'Завантаження…',
        download: 'Завантажити',
        openImage: 'Відкрити зображення',
        noActivity: 'Немає активності',
        pauseVoiceMessage: 'Призупинити голосове повідомлення',
        playVoiceMessage: 'Відтворити голосове повідомлення',
        patientTyping: 'Пацієнт друкує…',
        messageActions: 'Дії з повідомленням',
        editMessage: 'Редагувати',
        deleteMessage: 'Видалити',
        editedSuffix: 'редаговано',
        saveEdit: 'Зберегти',
        cancelEdit: 'Скасувати',
        editMessagePlaceholder: 'Редагувати повідомлення',
        confirmDeleteMessage: 'Видалити це повідомлення?',
        seekVoiceMessage: 'Перейти до позиції голосового повідомлення',
        playbackSpeed: 'Швидкість відтворення',
        adminAvatarAlt: 'Аватар {{name}}',
      },
      patientProfile: {
        active: 'Активний',
        inactive: 'Неактивний',
        emailLabel: 'Електронна пошта',
        notRegisteredYet:
          'Ще не зареєстровано — поділіться кодом запрошення з пацієнтом',
        birthDateLabel: 'Дата народження',
        genderLabel: 'Стать',
        genderMale: 'Чоловіча',
        genderFemale: 'Жіноча',
        genderOther: 'Інша',
        leadIdLabel: 'Lead ID',
        leadIdPlaceholder: 'Додати Lead ID',
        leadIdEmpty: 'Не вказано',
        leadIdSave: 'Зберегти',
        leadIdCancel: 'Скасувати',
        leadIdEdit: 'Редагувати',
        leadIdSaveFailed: 'Не вдалося зберегти Lead ID',
      },
      preparing: {
        title: 'Процедури',
        subtitle:
          'Керуйте підготовчими процедурами для цього етапу. Пацієнти бачать їх як список.',
        optional: "необов'язково",
        completedSummary: '{{done}} / {{total}} виконано',
        addSectionTitle: 'Нова процедура',
        noProceduresHint: 'Додайте процедуру нижче — пацієнт побачить її у списку.',
        statusPending: 'Очікує',
        statusCompleted: 'Виконано',
        statusVerified: 'Перевірено',
        markComplete: 'Позначити виконаним',
        verify: 'Перевірити',
        remove: 'Видалити',
        edit: 'Редагувати',
        save: 'Зберегти',
        cancel: 'Скасувати',
        saving: 'Збереження...',
        dragHandle: 'Перетягнути',
        noProcedures: 'Процедур ще немає.',
        procedureTitleLabel: 'Назва процедури',
        procedureTitlePlaceholder: 'наприклад, Панорамний знімок',
        descriptionLabel: "Опис (необов'язково)",
        descriptionPlaceholder: 'Деталі процедури...',
        required: "Обов'язково",
        yes: 'Так',
        no: 'Ні',
        adding: 'Додавання...',
        addProcedure: 'Додати процедуру',
      },
      modeling: {
        title: 'Моделювання',
        subtitle:
          'Налаштуйте кількість елайнерів по щелепах і завантажте медіа візуалізації.',
        upperJaw: 'Верхня щелепа',
        lowerJaw: 'Нижня щелепа',
        saving: 'Збереження...',
        saveAlignerCounts: 'Зберегти кількість елайнерів',
        saveSettings: 'Зберегти налаштування',
        visualizationTitle: 'Заголовок візуалізації',
        visualizationTitlePlaceholder: 'Наприклад: Відео руху зубів',
        visualizationDescription: 'Опис візуалізації',
        visualizationDescriptionPlaceholder:
          'Короткий опис, що пацієнт побачить у відео',
        visualizationMedia: 'Медіа візуалізації',
        mediaCountSummary: '{{videos}} відео • {{photos}} фото',
        addMedia: 'Додати медіа',
        deleteMedia: 'Видалити',
        mediaPhoto: 'Фото',
        mediaVideo: 'Відео',
        videoLimitReached: 'Можна завантажити лише одне відео.',
        photoLimitReached: 'Можна завантажити не більше 10 фото.',
        dragToReorder: 'Перетягніть, щоб змінити порядок',
        confirmDelete: 'Видалити цей файл?',
        status: 'Статус',
        dropOrBrowse:
          'Перетягніть сюди або натисніть, щоб обрати (відео + фото)',
        uploading: 'Завантаження...',
        treatmentDescription: 'Опис лікування',
        treatmentDescriptionPlaceholder:
          'Розгорнутий опис плану лікування, накладки, етапи курсу...',
        pricingSection: 'Вартість лікування',
        estimatedDays: 'Приблизна тривалість (днів)',
        alignerUnitPrice: 'Ціна за один елайнер',
        prepayment: 'Аванс (буде відрахований)',
        discount: 'Знижка (буде відрахована)',
        pricingCurrency: 'Валюта',
        additionalItems: 'Додаткові позиції',
        additionalItemName: 'Назва',
        additionalItemPrice: 'Ціна',
        addAdditionalItem: '+ Додати позицію',
        removeAdditionalItem: 'Видалити',
        pricingTotal: 'Сума до сплати',
        pricingPreview: 'Попередній перегляд для пацієнта',
        planSection: 'План лікування',
        summaryAligners: 'Елайнери ({{qty}} шт.)',
        summaryExtras: 'Додаткові позиції',
        planApprovedByPatient: 'Пацієнт погодив план лікування',
        planApprovedAt: 'Погоджено',
        planPendingApproval: 'Пацієнт ще не погодив план лікування',
        pricingSharedHint:
          'Ці значення спільні для всіх планів етапу. Кількість елайнерів і додаткові позиції задаються окремо в кожному плані.',
        visualizationHint:
          'Заголовок і опис показуються пацієнту над медіа візуалізації.',
        tabsLabel: 'Розділи кроку «Моделювання»',
        tabPlans: 'Плани',
        tabSettings: 'Загальні налаштування',
        tabMedia: 'Медіа',
        unsavedChanges: 'Незбережені зміни',
        selectedPlanLabel: 'Обраний план',
        noSelectedPlan: 'План ще не обрано',
      },
      planOptions: {
        title: 'Плани лікування',
        subtitle:
          'Основний план і альтернативи. Пацієнт бачить лише опубліковані плани та обирає один із них.',
        empty: 'Планів ще немає. Додайте основний план, щоб пацієнт побачив пропозицію.',
        addMain: '+ Додати основний план',
        addAlternative: '+ Додати альтернативний план',
        mainPlanTitle: 'Основний план',
        alternativePlanTitle: 'Альтернативний план {{index}}',
        mainBadge: 'Основний',
        selectedBadge: 'Обрано пацієнтом',
        published: 'Опубліковано',
        unpublished: 'Чернетка',
        showToPatient: 'Показувати пацієнту',
        selectForPatient: 'Обрати для пацієнта',
        selectNeedsCounts: 'Спочатку вкажіть кількість елайнерів',
        resetSelection: 'Скинути вибір',
        confirmDelete: 'Видалити план «{{title}}» разом із 3D-моделями?',
        planTitle: 'Назва плану',
        sectionIdentity: 'План',
        clinicalComment: 'Коментар лікаря',
        clinicalCommentHint: "Клінічний опис плану — обов'язкове поле",
        clinicalCommentPlaceholder:
          'Опишіть клінічний план, ключові акценти та рекомендації для пацієнта…',
        wholeCourse: 'Весь курс вирівнювання',
        wholeCourseHint: 'Курсові параметри не використовуються у розрахунку вартості етапу.',
        estimatedStages: 'Орієнтовна кількість етапів',
        maxCourseAligners: 'Максимум елайнерів на весь курс',
        currentStage: 'Поточний етап',
        currentStageHint: 'Тривалість розраховується автоматично; за потреби вкажіть її вручну.',
        setupAligners: 'Setup-елайнери (необов’язково)',
        daysPerAligner: 'Днів на один елайнер (типово 10)',
        durationOverride: 'Тривалість вручну (авто: {{days}} днів)',
        stageDerived:
          'Виготовляється на етапі: {{manufactured}} · Тривалість: {{duration}} днів · Setup-елайнери входять у виробництво й ціну, але не подовжують тривалість.',
        alignerPricing: 'Вартість елайнерів',
        alignerPricingHint: 'Кількість береться з клінічних полів вище — тут задається ціна.',
        pricingMode: 'Режим розрахунку елайнерів',
        pricingAuto: 'Авто',
        pricingCustom: 'Вручну',
        regularAligner: 'Звичайний',
        customAligner: 'Інший тип',
        autoPricingLine: 'Звичайні · {{manufactured}} шт.',
        unitPrice: 'Ціна за одиницю, {{currency}}',
        itemType: 'Тип',
        alignerJaw: 'Щелепа',
        alignerJawUpper: 'Верхня',
        alignerJawLower: 'Нижня',
        alignerJawNone: 'Без прив’язки',
        alignerKind: 'Вид елайнера',
        alignerKind_REGULAR: 'Звичайний',
        alignerKind_WITH_OVERLAYS: 'З накладками',
        alignerKind_SETUP: 'Setup-елайнер',
        alignerKind_RETENTION_CAP: 'Ретенційна капа',
        alignerKind_CUSTOM: 'Інший вид',
        customAlignerName: 'Назва іншого виду',
        quantity: 'Кількість',
        allocationOk:
          'Лікувальні елайнери: {{allocated}} з {{manufactured}} · Ретенційні капи: {{retention}}.',
        allocationMismatch:
          'Лікувальні елайнери: {{allocated}} з {{manufactured}} — виправте кількість. Ретенційні капи: {{retention}}.',
        addAlignerItem: '+ Додати товар',
        removeAlignerItem: 'Видалити товар',
        structuredElements: 'Додаткові елементи',
        structuredElementsHint: 'Активуйте лише потрібні блоки — неактивні пацієнт не побачить.',
        attachments: 'Атачменти',
        optionalQuantity: 'Кількість (необов’язково)',
        doctorComment: 'Коментар лікаря',
        buttons: 'Кнопки',
        elastics: 'Еластики',
        sets: 'Кількість наборів',
        separation: 'Потрібна сепарація',
        price: 'Ціна, {{currency}}',
        typeComment: 'Тип / коментар',
        otherClinicalElements: 'Інші клінічні елементи',
        addClinicalElement: '+ Додати клінічний елемент',
        elementTitle: 'Назва',
        elementDescription: 'Опис',
        paid: 'Платний',
        removeClinicalElement: 'Видалити клінічний елемент',
        schemeImage: 'Схема / зображення',
        schemeImages: 'Схеми / зображення',
        schemeUpload: 'Додати зображення',
        schemeReplace: 'Замінити',
        schemeDelete: 'Видалити',
        schemeUploading: 'Завантаження…',
        schemeRequirements: 'JPEG, PNG або WebP · до 10 МБ',
        schemeSaveFirst: 'Спочатку збережіть зміни в плані.',
        schemeInvalidType: 'Оберіть зображення у форматі JPEG, PNG або WebP.',
        schemeInvalidSize: 'Зображення має бути не більше 10 МБ.',
        schemeTooMany: 'Можна додати до {{max}} зображень для одного елемента.',
        schemeLimitReached: 'Додано максимум: {{max}}',
        schemePreviewAltNumbered: '{{label}} — зображення {{number}}',
        schemeUntitled: 'Зображення без назви',
        schemePreviewAlt: 'Схема: {{label}}',
        schemePreviewLoading: 'Завантаження зображення…',
        schemePreviewError: 'Не вдалося завантажити зображення.',
        depositDiscounts: 'Депозит і знижки',
        depositAmount: 'Сума депозиту, {{currency}}',
        discountsPromotions: 'Знижки / акції',
        addDiscount: '+ Додати знижку / акцію',
        discountName: 'Назва',
        discountComment: 'Коментар',
        discountAmount: 'Сума, {{currency}}',
        removeDiscount: 'Видалити знижку',
        keyDifference: 'Ключова відмінність планів',
        keyDifferencePlaceholder: 'Чим цей план відрізняється від основного…',
        currencyUah: 'грн',
        validationFix: 'Виправте помилки в плані перед збереженням.',
        publishNeedsSavedValid: 'Спочатку збережіть коректний план.',
        selectNeedsPublished: 'Спочатку опублікуйте план.',
        validation_clinical_comment_required: 'Додайте коментар лікаря.',
        validation_custom_quantity_mismatch:
          'Розподіл елайнерів за типами має дорівнювати клінічній кількості.',
        validation_integer_invalid: 'Кількість має бути цілим числом без дробів або експоненти.',
        validation_value_out_of_range: 'Одне або кілька значень виходять за дозволені межі.',
        validation_money_invalid: 'Сума має бути невід’ємною та містити не більше двох знаків після коми.',
        validation_text_too_long: 'Скоротіть текст до дозволеної довжини.',
        validation_list_too_long: 'Забагато позицій у одному з переліків.',
        validation_required_label: 'Заповніть назви всіх доданих позицій.',
        upperJaw: 'Верхня щелепа (елайнерів)',
        lowerJaw: 'Нижня щелепа (елайнерів)',
        summaryAligners: 'Елайнери ({{qty}} шт.)',
        summaryExtras: 'Додаткові позиції',
        summaryDiscount: 'Знижка',
        summaryPrepayment: 'Аванс',
        summaryDeposit: 'Депозит',
        pricingTotal: 'Сума до сплати',
        pricingPreview: 'Розрахунок для пацієнта',
        pricingUnavailable: 'Вкажіть ціну за елайнер у блоці «Вартість лікування», щоб побачити суму.',
        savePlan: 'Зберегти план',
        saving: 'Збереження…',
        meshSection: '3D-моделі (STL)',
        view3d: 'Переглянути 3D',
        jaw_upper: 'Верхня',
        jaw_lower: 'Нижня',
        role_current: 'Зараз',
        role_result: 'Результат',
        meshUpload: 'Завантажити STL',
        meshReplace: 'Замінити',
        meshDelete: 'Видалити',
        meshUntitledFile: 'Файл без назви',
        meshStatusEmpty: 'Немає файлу',
        meshStatusPending: 'У черзі',
        meshStatusProcessing: 'Обробка…',
        meshStatusReady: 'Готово',
        meshStatusFailed: 'Помилка',
        viewerLoadFailed: 'Не вдалося завантажити модель.',
        viewerSourceFallback:
          'Показано вихідний STL — оптимізована версія ще готується, тож завантаження може бути повільним.',
        viewerPreviewPending_one:
          'Ще {{count}} модель готується — вона з’явиться, щойно сервер завершить обробку.',
        viewerPreviewPending_few:
          'Ще {{count}} моделі готуються — вони з’являться, щойно сервер завершить обробку.',
        viewerPreviewPending_many:
          'Ще {{count}} моделей готуються — вони з’являться, щойно сервер завершить обробку.',
        viewerPreviewPending_other:
          'Ще {{count}} моделей готуються — вони з’являться, щойно сервер завершить обробку.',
        meshReprocess: 'Повторити обробку',
        meshStalled: 'Обробка триває довше, ніж очікувалося. Спробуйте повторити.',
        unsavedChanges: 'Незбережені зміни',
        unsavedHint: 'Зміни ще не збережені',
        plansNavLabel: 'Список планів',
        railCounts: '{{upper}} / {{lower}} елайнерів',
        railMeshes: '{{ready}}/{{total}} STL',
        railNoPrice: 'Ціни немає',
      },
      movementSteps: {
        title: 'Рух зубів',
        subtitle:
          'Послідовність кроків (0…N) по щелепах. Пацієнт переглядає її на етапах оплати та доставки.',
        empty: 'Кроків ще немає. Додайте перший крок і завантажте STL.',
        addStep: '+ Додати крок',
        deleteStep: 'Видалити крок',
        stepLabel: 'Крок {{index}}',
        confirmDeleteStep: 'Видалити крок {{index}} разом із 3D-моделями?',
      },
      delivery: {
        title: 'Доставка',
        subtitle: 'Адресу пацієнт додає у застосунку. Створіть відправлення й додайте ТТН.',
        addressCardTitle: 'Адреса',
        shipment: 'Відправлення',
        notCreated: 'Не створено',
        shippedAt: 'Відправлено',
        deliveredAt: 'Доставлено',
        receivedAt: 'Пацієнт підтвердив отримання',
        save: 'Зберегти',
        patientDeliveryDetails: 'Адреса доставки пацієнта',
        loadingAddresses: 'Завантаження адрес…',
        noDeliveryAddress:
          'Адрес доставки ще немає. Пацієнт може додати їх у застосунку під час кроку доставки.',
        addressId: 'ID адреси',
        shipTo: 'Куди відправляємо',
        selectAddress: 'Оберіть адресу…',
        createDelivery: 'Створити доставку',
        deliveryStatus: 'Статус',
        tracking: 'Трекінг',
        consignmentNote: 'Накладна',
        trackingNumber: 'Номер відправлення (ТТН)',
        enterTTH: 'Введіть номер ТТН',
        saveTrackingNumber: 'Зберегти трекінг',
        confirmPatientReceived: 'Підтвердити отримання пацієнтом',
        deliveryManagement: 'Управління доставкою',
        createDeliverySection: 'Створити доставку',
        deliveryAddressId: 'ID адреси доставки',
        addressIdPlaceholder: 'ID адреси',
        updateTracking: 'Оновити трекінг',
        tthPlaceholder: 'Номер ТТН',
        method: {
          novaPoshta: 'Нова Пошта',
          ukrposhta: 'Укрпошта',
          international: 'Міжнародна доставка',
        },
      },
      wearing: {
        title: 'Набори елайнерів',
        subtitle:
          'Пацієнт керує носінням з мобільного застосунку. Кількість елайнерів для кожної щелепи можна змінити, поки він не почав носіння.',
        upper: 'Верхні',
        lower: 'Нижні',
        aligners: 'елайнерів',
        started: 'Носіння з',
        alignerCountChip: '{{total}} елайнерів',
        estimatedWear: '≈ {{days}} дн. носіння',
        progressTitle: 'Прогрес носіння',
        upperJaw: 'Верхня щелепа',
        lowerJaw: 'Нижня щелепа',
        numberOfAligners: 'Кількість елайнерів',
        daysPerAligner: 'Днів на елайнер',
        currentCount: 'Зараз: {{count}}',
        notConfigured: 'Ще не налаштовано',
        creating: 'Збереження…',
        createSets: 'Створити',
        updateSets: 'Замінити',
        savedJustNow: '✓ Збережено',
        cannotEditStarted:
          'Пацієнт уже почав носіння — кількість змінити не можна.',
        sameValueHint: 'Змініть кількість, щоб зберегти.',
        progress: {
          upperHeader: 'Верхня щелепа — прогрес',
          lowerHeader: 'Нижня щелепа — прогрес',
          summaryActive: 'Поточний №{{number}}',
          summaryIdle: '{{total}} елайнерів',
          alignerLabel: 'Елайнер {{number}}',
          statusNotStarted: 'Не розпочато',
          statusWearing: 'Носиться',
          statusPaused: 'На паузі',
          statusCompleted: 'Завершено',
          daysWornOfTarget: '{{worn}} / {{target}} днів',
          daysHoursWorn: '{{days}} дн {{hours}} год',
          edit: 'Редагувати',
          save: 'Зберегти',
          cancel: 'Скасувати',
          editTitle: 'Коригування носіння',
          statusField: 'Статус',
          editAlignerN: 'Редагувати елайнер {{number}}',
          daysInput: 'Дні',
          hoursInput: 'Години',
          saveError: 'Не вдалося зберегти. Спробуйте ще раз.',
          saved: 'Збережено',
          targetExceededWarning:
            'Уведений час перевищує цільову тривалість елайнера.',
          noAlignersHint: 'Набори елайнерів ще не створено.',
        },
      },
      stageEditor: {
        stageN: 'Етап {{number}}',
        saving: 'Збереження…',
        failedToSave: 'Не вдалося зберегти',
        finishing: 'Завершення...',
        finishStage: 'Завершити етап',
        failedToFinish: 'Не вдалося завершити',
        changeStage: 'Змінити крок',
        changeStageTitle: 'Змінити поточний етап',
        changeStageHint:
          'Цей етап бачить пацієнт у мобільному застосунку. Підтвердьте зміну.',
        confirmChange: 'Підтвердити',
        cancel: 'Скасувати',
        deleteStage: 'Видалити етап',
        preparing: 'Підготовка',
        modeling: 'Моделювання',
        payment: 'Оплата',
        delivery: 'Доставка',
        wearing: 'Носіння',
        paymentMovedNotice:
          'Оплати тепер керуються із розділу «Оплати» на сторінці клієнта.',
        paymentOpenSection: 'Перейти до розділу «Оплати»',
        upper: 'Верхні',
        lower: 'Нижні',
        noTreatmentsYet: 'Немає лікувань.',
        untitledTreatment: 'Без назви',
        stages: 'Етапи',
        created: 'Створено',
        finishCycle: 'Завершити етап',
        finishingCycle: 'Завершення...',
        finishCycleConfirm: 'Завершити етап?',
        finishCycleRequiresNext:
          'Створіть наступний етап, щоб завершити цей вручну. Останній етап завершується автоматично після носіння всіх елайнерів.',
        resumeCycle: 'Відновити етап',
        resumingCycle: 'Відновлення...',
        activateCycle: 'Активувати етап',
        activatingCycle: 'Активація...',
        cancelCycle: 'Скасувати етап',
        cancellingCycle: 'Скасування...',
        cancelCycleConfirm: 'Скасувати етап?',
        cycleStatus: {
          draft: 'Чернетка',
          in_progress: 'У роботі',
          completed: 'Завершено',
          cancelled: 'Скасовано',
        },
        patientBannerLabel: 'Пацієнт зараз бачить',
        patientBannerHint:
          'Коли цей етап завершено — переведіть пацієнта на наступний, щоб оновити мобільний застосунок.',
        movePatientTo: 'Перевести пацієнта на інший крок',
        movePatientHere: 'Перевести пацієнта сюди',
        movePatientConfirm:
          'Перевести пацієнта на «{{stage}}»? Це оновить поточний крок у мобільному застосунку.',
        patientRemainsAt: 'Пацієнт залишається на кроці «{{stage}}».',
        patientTabBadge: 'Бачить пацієнт',
        adminViewBadge: 'Ваш вигляд',
        patientAtThisStage: 'Пацієнт зараз тут',
        toggleStage: 'Розгорнути або згорнути етап',
      },
      alignerPanel: {
        title: 'Набори елайнерів',
        upper: 'Верхні',
        lower: 'Нижні',
        aligners: 'елайнерів',
        createTitle: 'Створити набори елайнерів',
        createHint:
          'Групово створити по одному разу на щелепу за етап. Якщо набори вже існують для вибраної щелепи, створення відхиляється — використайте іншу щелепу або спочатку видаліть наявні набори.',
        jaw: 'Щелепа',
        upperJaw: 'Верхня',
        lowerJaw: 'Нижня',
        numberOfAligners: 'Кількість елайнерів',
        daysPerAligner: 'Днів на елайнер',
        creating: 'Створення...',
        createSets: 'Створити набори',
      },
      cyclePayment: {
        title: 'Управління оплатою',
        createPaymentTitle: 'Створити оплату',
        bankAccountId: 'ID банківського рахунку',
        bankAccountIdPlaceholder: 'ID банківського рахунку',
        amount: 'Сума',
        currency: 'Валюта',
        deadline: 'Термін оплати',
        createBtn: 'Створити оплату',
      },
      photoSchedule: {
        everyNDays: 'Кожні {{days}} днів',
      },
      profile: {
        title: 'Мій профіль',
        avatarSection: 'Фото профілю',
        personalInfoSection: 'Особисті дані',
        passwordSection: 'Зміна пароля',
        fullName: 'Повне імʼя',
        firstName: 'Імʼя',
        lastName: 'Прізвище',
        phoneNumber: 'Телефон',
        telegramUsername: 'Telegram',
        telegramHelp: 'Без @, наприклад: white_and_flex',
        optionalPlaceholder: 'Необовʼязково',
        currentPassword: 'Поточний пароль',
        newPassword: 'Новий пароль',
        confirmNewPassword: 'Підтвердіть новий пароль',
        changePhoto: 'Змінити фото',
        removePhoto: 'Видалити фото',
        uploading: 'Завантаження…',
        removing: 'Видалення…',
        savePersonal: 'Зберегти зміни',
        saving: 'Збереження…',
        changePassword: 'Змінити пароль',
        saveSuccess: 'Зміни збережено.',
        passwordSuccess: 'Пароль успішно змінено.',
        passwordMismatch: 'Новий пароль і підтвердження не співпадають.',
        passwordTooShort: 'Пароль має містити щонайменше {{count}} символів.',
        avatarTooLarge: 'Файл перевищує 5 МБ.',
        avatarInvalidType: 'Дозволені формати: PNG, JPEG, WebP.',
        avatarUploadError: 'Не вдалося завантажити фото',
        removeConfirm: 'Видалити поточне фото профілю?',
      },
    },
  },
  en: {
    translation: {
      common: {
        language: 'Language',
        ukrainian: 'Ukrainian',
        english: 'English',
        signOut: 'Sign out',
        appBarMenu: 'Menu',
        collapseSidebar: 'Collapse sidebar',
        expandSidebar: 'Expand sidebar',
        backToDashboard: 'Back to dashboard',
        system: 'System',
        emptyTitle: 'Nothing found',
        emptyDescription: 'Try adjusting your filters or come back later.',
        openProfile: 'Open profile',
      },
      dialog: {
        confirmTitle: 'Confirm action',
        confirm: 'Confirm',
        cancel: 'Cancel',
        close: 'Close dialog',
        delete: 'Delete',
        inputLabel: 'Comment',
        required: 'Complete this field',
      },
      nav: {
        dashboard: 'Dashboard',
        clients: 'Clients',
        chats: 'Chats',
        activity: 'Activity',
        testimonials: 'Testimonials',
        tasks: 'Tasks',
        bankAccounts: 'Bank accounts',
        pointsRewards: 'Bonus rewards',
        team: 'Team',
        roles: 'Roles',
        adminPanel: 'Admin Panel',
      },
      theme: {
        label: 'Theme',
        light: 'Light',
        dark: 'Dark',
      },
      meshViewer: {
        title: '3D model',
        viewGroup: 'View',
        viewCurrent: 'Current',
        viewResult: 'Result',
        viewOverlay: 'Overlay',
        jawGroup: 'Jaw',
        jawUpper: 'Upper',
        jawLower: 'Lower',
        jawBoth: 'Both',
        presetGroup: 'Angle',
        presetFront: 'Front',
        presetLeft: 'Left',
        presetRight: 'Right',
        presetTop: 'Top',
        presetBottom: 'Bottom',
        reset: 'Reset camera',
        stepGroup: 'Tooth movement',
        stepLabel: 'Step {{index}}',
        stepPosition: '{{position}}/{{total}}',
        play: 'Play',
        pause: 'Pause',
        loading: 'Loading model…',
        empty: 'No models to display',
        errorTitle: 'The model could not be displayed',
        errorUnsupported:
          'This browser does not support 3D viewing. Update it or open the page on another device.',
        errorDecode: 'The model file is damaged or in an unsupported format.',
        errorGeneric: 'Try reloading the page.',
      },
      testimonials: {
        title: 'Testimonials',
        subtitle:
          'Patient ratings and comments on completed stages · {{count}}',
        stageN: 'Stage {{number}}',
        noComment: 'No comment',
        viewProfile: 'View patient profile',
        emptyTitle: 'No testimonials yet',
        emptyDescription:
          'Patient testimonials will appear here after stages are completed.',
        loadErrorTitle: 'Failed to load testimonials',
        loadErrorDescription: 'Please try refreshing the page later.',
      },
      team: {
        title: 'Team',
        subtitle: 'Administrators and invitations',
      },
      tasks: {
        title: 'Tasks',
        create: 'Create task',
        creating: 'Creating…',
        save: 'Save',
        saving: 'Saving…',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        complete: 'Complete',
        deadline: 'Deadline',
        priority: 'Priority',
        status: 'Status',
        assignees: 'Assignees',
        relatedPatient: 'Related patient',
        relatedPatientPlaceholder: 'Select a patient (optional)',
        relatedPayment: 'Related payment',
        noTasks: 'No tasks',
        noTasksDescription: 'Create a new task or clear the filters.',
        noAdmins: 'No administrators found',
        overdue: 'overdue',
        mineOnly: 'Mine only',
        search: 'Search',
        filterAny: 'Any',
        confirmDelete: 'Delete this task?',
        descriptionPlaceholder: 'Task description (optional)',
        titlePlaceholder: 'Task title',
        labelTitle: 'Title',
        labelDescription: 'Description',
        newTaskTitle: 'New task',
        editTaskTitle: 'Edit task',
        loadErrorTitle: 'Unable to load tasks',
        loadErrorDescription: 'Try again in a moment.',
        statusLabels: {
          pending: 'Pending',
          in_progress: 'In progress',
          completed: 'Completed',
          cancelled: 'Cancelled',
        },
        priorityLabels: {
          low: 'Low',
          medium: 'Medium',
          high: 'High',
          urgent: 'Urgent',
        },
        sourceLabels: {
          manual: 'Manual',
          payment_verification: 'Payment verification',
        },
      },
      patientPicker: {
        placeholder: 'Select a patient',
        searchPlaceholder: 'Search patient…',
        noResults: 'No patients found',
        loading: 'Loading…',
        clear: 'Clear selection',
      },
      notifications: {
        pageTitle: 'Notifications',
        bellTitle: 'Notifications',
        viewAll: 'View all',
        noNew: 'No new notifications',
        markRead: 'Mark as read',
        markUnread: 'Mark as unread',
        delete: 'Delete',
        unread: 'Unread',
        unreadOnly: 'Unread only',
        filterCategory: 'Category',
        filterAny: 'Any',
        empty: 'No notifications',
        loading: 'Loading…',
        confirmDelete: 'Delete this notification?',
        loadErrorTitle: 'Unable to load notifications',
        loadErrorDescription: 'Try again in a moment.',
        loadMore: 'Load more',
        previous: 'Previous',
        next: 'Next',
        justNow: 'just now',
        minutesAgo: '{{count}}m ago',
        hoursAgo: '{{count}}h ago',
        daysAgo: '{{count}}d ago',
        categoryLabels: {
          patient_registered: 'New patient',
          payment_submitted: 'Payment submitted',
          payment_overdue: 'Payment overdue',
          chat_unread: 'Unread chat message',
          final_result_submitted: 'Final photo protocol',
        },
      },
      points: {
        balance: 'Points balance',
        balanceUnit: 'points',
        balanceUah: '≈ {{amount}} {{currency}}',
        lifetimeGranted: 'Granted overall',
        lifetimeRedeemed: 'Redeemed overall',
        pricingHint:
          'Points do not change a price automatically. Check the balance, decide the discount, enter the reduced amount on the invoice, then redeem the points here.',
        grantTitle: 'Grant points',
        grantPoints: 'Points to grant',
        grantNote: 'Grant note',
        grantNotePlaceholder: 'e.g. referred a friend',
        grantCta: 'Grant',
        granting: 'Granting…',
        redeemTitle: 'Redeem points',
        redeemReward: 'Reward',
        redeemFreeForm: 'Other (enter manually)',
        redeemPoints: 'Points to redeem',
        redeemPointsOverrideHint: 'Leave empty to charge the reward cost',
        redeemNote: 'Redemption note',
        redeemCta: 'Redeem',
        redeeming: 'Redeeming…',
        redeemInsufficient: 'Not enough points on the balance.',
        reverseCta: 'Reverse',
        confirmReverse:
          'Reverse this entry? An opposite entry is added and the history is kept.',
        reversedBadge: 'reversed',
        historyTitle: 'History',
        colDate: 'Date',
        colDelta: 'Points',
        colReason: 'Operation',
        colReward: 'Reward',
        colNote: 'Note',
        colAdmin: 'Admin',
        emptyDescription: 'No points activity yet.',
        loadErrorTitle: 'Could not load points',
        loadErrorDescription: 'Try reloading the page.',
        reasonLabels: {
          manual_grant: 'Grant',
          redemption: 'Redemption',
          reversal: 'Reversal',
        },
      },
      pointsRewards: {
        title: 'Bonus rewards',
        subtitle:
          'The catalog of what points can be spent on. 1 point = 1 UAH. Inactive rewards are hidden from the list.',
        addReward: 'Add reward',
        showInactive: 'Show inactive',
        hideInactive: 'Hide inactive',
        newRewardTitle: 'New reward',
        editRewardTitle: 'Edit reward',
        labelNameUk: 'Name (UK)',
        labelNameEn: 'Name (EN)',
        placeholderNameUk: 'Напр., Безкоштовний ретейнер',
        placeholderNameEn: 'e.g. Free retainer',
        labelPointCost: 'Cost in points',
        pointCostHint: '1 point = 1 UAH',
        labelRewardType: 'Type',
        labelActive: 'Active',
        costBadge: '{{count}} pts',
        inactiveBadge: 'inactive',
        colNameEn: 'EN',
        colType: 'Type',
        cancel: 'Cancel',
        create: 'Create',
        creating: 'Creating…',
        save: 'Save',
        saving: 'Saving…',
        edit: 'Edit',
        deactivate: 'Deactivate',
        confirmDeactivate:
          'Deactivate this reward? It disappears from the picker; past redemptions keep their history.',
        emptyTitle: 'No rewards yet',
        emptyDescription: 'Add the first reward so every admin redeems points the same way.',
        loadErrorTitle: 'Could not load rewards',
        loadErrorDescription: 'Try reloading the page.',
        rewardTypeLabels: {
          treatment_discount: 'Treatment discount',
          item: 'Item or service',
        },
      },
      bankAccounts: {
        title: 'Bank accounts',
        subtitle:
          'Details shown to patients for payments. Deactivated accounts are hidden from this list.',
        addAccount: 'Add account',
        cancel: 'Cancel',
        create: 'Create account',
        creating: 'Creating…',
        save: 'Save',
        saving: 'Saving…',
        edit: 'Edit',
        deactivate: 'Deactivate',
        confirmDeactivate:
          'Deactivate this account? It will no longer appear when creating payments.',
        loadErrorTitle: 'Unable to load bank accounts',
        loadErrorDescription: 'Try again in a moment.',
        emptyTitle: 'No active accounts',
        emptyDescription: 'Add your first bank account.',
        colAccountName: 'Account name',
        colBank: 'Bank',
        colIban: 'IBAN',
        colSwift: 'SWIFT',
        colCurrency: 'Currency',
        colAccountNumber: 'Account no.',
        colPrivacyOffer: 'Public offer',
        actions: 'Actions',
        newAccountTitle: 'New bank account',
        editAccountTitle: 'Edit bank account',
        labelAccountName: 'Account name',
        labelBankName: 'Bank name',
        labelIban: 'IBAN',
        labelSwift: 'SWIFT (optional)',
        labelAccountNumber: 'Account number (optional)',
        labelCurrency: 'Currency',
        labelPrivacyOffer: 'Public offer (text)',
        placeholderAccountName: 'e.g. White&Flex UAH',
        placeholderBank: 'e.g. Demo Bank',
        placeholderIban: 'IBAN…',
        placeholderPrivacyOffer:
          'Public offer text shown to patients before payment.',
      },
      auth: {
        adminAccess: 'White&Flex admin access',
        signInTitle: 'Sign in to the CRM workspace',
        signInDescription:
          'Secure access for operations, treatment coordination, and the internal workflows tied to the White&Flex platform.',
        brandNoteDescription:
          'Gradients stay atmospheric. Dense workflows remain on calm light surfaces to preserve contrast and readability.',
        authentication: 'Authentication',
        welcomeBack: 'Welcome back',
        signInHint:
          'Use the bootstrap admin credentials or wire this screen to the live auth service.',
        signInError: 'Unable to sign in.',
        invalidCredentials: 'Invalid credentials.',
        adminOnly: 'CRM access is restricted to administrators.',
        tooManyAttempts: 'Too many attempts. Please try again later.',
        email: 'Email',
        password: 'Password',
        signingIn: 'Signing in...',
        signIn: 'Sign in to dashboard',
        accessRestricted:
          'Access is restricted to authenticated White&Flex administrators.',
        forgotPasswordLink: 'Forgot password?',
        forgotPasswordTitle: 'Forgot your password?',
        forgotPasswordHint:
          'If this email belongs to an administrator account, we will send a 4-digit code and a reset link to it.',
        forgotPasswordSubmit: 'Send code',
        sendingResetCode: 'Sending code...',
        forgotPasswordError: 'Failed to send the code. Please try again.',
        resetPasswordTitle: 'Reset password',
        resetPasswordHint: 'Enter the 4-digit code from the email and choose a new password.',
        resetPasswordCodeSent:
          'If this email belongs to an administrator account, a 4-digit code and a reset link were sent to {{email}}. Enter the code and choose a new password.',
        resetPasswordInvalidLink: 'This password reset link is invalid.',
        resetPasswordError: 'Failed to reset password. Check the code and try again.',
        resetPasswordSuccess: 'Password changed. You can now sign in.',
        resetCode: 'Verification code',
        newPassword: 'New password',
        confirmNewPassword: 'Confirm new password',
        resettingPassword: 'Changing password...',
        resetPasswordSubmit: 'Change password',
        backToSignIn: 'Back to sign in',
        requestNewCode: 'No code received? Send a new one',
      },
      dashboard: {
        greeting: 'Welcome back, {{name}}',
        justNow: 'Just now',
        hoursAgo_one: '{{count}}h ago',
        hoursAgo_other: '{{count}}h ago',
        daysAgo_one: '{{count}}d ago',
        daysAgo_other: '{{count}}d ago',
        totalPatients: 'Total patients',
        activeTreatments: 'Active treatments',
        pendingDeliveries: 'Pending deliveries',
        pendingPayments: 'Pending payments',
        recentActivity: 'Recent activity',
        quickActions: 'Quick actions',
        viewAllClients: 'View all clients',
        addNewPatient: 'Add new patient',
      },
      clients: {
        title: 'Clients',
        totalPatients_one: '{{count}} patient total',
        totalPatients_other: '{{count}} patients total',
        addClient: 'Add client',
        searchPlaceholder: 'Search by name, email, or ID...',
        searchGeneric: 'Search...',
        clearFilters: 'Clear filters',
        filters: 'Filters',
        filterByAdmin: 'Assigned admins',
        filterByStage: 'Stage',
        filterByStep: 'Step',
        filterByAccountState: 'Account state',
        filterByUpdated: 'Updated date range',
        updatedFrom: 'From',
        updatedTo: 'To',
        accountAny: 'Any',
        accountPending: 'Pending',
        accountActive: 'Active',
        accountInactive: 'Inactive',
        applyFilters: 'Apply',
        clearAllFilters: 'Clear all',
        anyStage: 'Any',
        adminTag: 'Admin: {{value}}',
        stageTag: 'Stage: {{value}}',
        stepTag: 'Step: {{value}}',
        cycleTag: 'Stage: {{value}}',
        accountTag: 'Account: {{value}}',
        updatedFromTag: 'Updated from: {{value}}',
        updatedToTag: 'Updated to: {{value}}',
        searchTag: 'Search: {{value}}',
        statusTag: 'Status: {{value}}',
        loadErrorTitle: 'Unable to load clients',
        loadErrorDescription: 'Try again in a moment.',
        emptyTitle: 'No clients found',
        emptySearch: 'Try a different search term.',
        emptyDefault: 'Add your first client to get started.',
        all: 'All',
        patient: 'Patient',
        status: 'Status',
        account: 'Account',
        email: 'Email',
        updated: 'Updated',
        actions: 'Actions',
        noClientId: 'No client ID',
        pendingSignup: 'Pending signup',
        active: 'Active',
        inactive: 'Inactive',
        open: 'Open',
        chat: 'Chat',
        scopeMine: 'My patients',
        scopeAll: 'All patients',
        assignedAdmins: 'Assigned',
        noAssignedAdmins: '—',
        emptyMineTitle: 'You have no assigned patients yet',
        emptyMineDescription: 'Switch to "All patients" to see the full list.',
        rowsPerPage: 'Rows per page:',
        rangeOfTotal: '{{from}}-{{to}} of {{total}}',
        previousPage: 'Previous page',
        nextPage: 'Next page',
        copied: 'Copied',
        copyFailed: 'Copy failed — select the code manually',
        inviteCodeReady: 'Invite code ready',
        createClient: 'Create client',
        inviteCodeDescription:
          'Share this code with the patient so they can finish registration in the mobile app.',
        createClientDescription:
          'We only store the name in the clinic record. The patient chooses email and password (or Google / Apple) when they register.',
        closeCreateClientForm: 'Close create client form',
        codeForPatient: 'Code for {{name}} — valid until they complete signup.',
        copy: 'Copy',
        close: 'Close',
        openClientRecord: 'Open client record',
        firstName: 'First name',
        lastName: 'Last name',
        cancel: 'Cancel',
        creating: 'Creating...',
        createAndShowCode: 'Create and show code',
        delete: 'Delete',
        deleteClientTitle: 'Delete client',
        deleteClientConfirm:
          'Delete client "{{name}}"? This action cannot be undone.',
        deleting: 'Deleting...',
        deleteFailed: 'Failed to delete client.',
        moreActions: 'More actions',
        viewTable: 'Table',
        viewFunnel: 'Funnel',
        funnel: {
          stageGroup: 'Stage {{number}}',
          noCycle: 'No stage',
          emptyColumn: 'No patients',
          loadMore: 'Load more ({{count}})',
          loading: 'Loading...',
          moving: 'Moving...',
          moveConfirmTitle: 'Move patient',
          moveConfirmBody: 'Move {{name}} to the "{{step}}" step?',
          moveConfirmCta: 'Move',
          moveError: 'Could not move the patient. Please try again.',
        },
      },
      stages: {
        preparing: 'Preparing',
        modeling: 'Modeling',
        payment: 'Payment',
        manufacturing_delivery: 'Manufacturing & delivery',
        wearing_aligners: 'Wearing aligners',
      },
      activity: {
        title: 'Activity',
        entries_one: '{{count}} entry',
        entries_other: '{{count}} entries',
        all: 'All',
        patient: 'Patient',
        treatment: 'Treatment',
        stage: 'Stage',
        chat: 'Chat',
        assigned: 'Assigned',
        search: 'Search activity...',
        from: 'From',
        to: 'To',
        clearFilters: 'Clear filters',
        loadErrorTitle: 'Unable to load activity',
        loadErrorDescription: 'Try again in a moment.',
        emptyTitle: 'No activity found',
        emptyFiltered: 'Try adjusting your filters.',
        emptyDefault: 'Activity will appear here as admins take actions.',
        time: 'Time',
        admin: 'Admin',
        action: 'Action',
        patientColumn: 'Patient',
        summary: 'Summary',
        rowsPerPage: 'Rows per page:',
        ofTotal: '{{from}}-{{to}} of {{total}}',
        previousPage: 'Previous page',
        nextPage: 'Next page',
        actionLabels: {
          patient_created: 'Patient Created',
          patient_updated: 'Patient Updated',
          treatment_created: 'Treatment Created',
          treatment_updated: 'Treatment Updated',
          cycle_created: 'Cycle Created',
          cycle_updated: 'Cycle Updated',
          stage_updated: 'Stage Updated',
          payment_confirmed: 'Payment Confirmed',
          payment_rejected: 'Payment Rejected',
          delivery_updated: 'Delivery Updated',
          chat_assigned: 'Chat Assigned',
          chat_message_sent: 'Chat Message',
        },
      },
      error: {
        notFound: 'This route is not part of the current CRM shell.',
        forbidden: 'You do not have permission to access this page.',
      },
      status: {
        draft: 'Draft',
        active: 'Active',
        completed: 'Completed',
        cancelled: 'Cancelled',
        not_started: 'Not started',
        in_progress: 'In progress',
        blocked: 'Blocked',
        pending: 'Pending',
        preparing_shipment: 'Preparing shipment',
        shipped: 'Shipped',
        delivered: 'Delivered',
        submitted_by_patient: 'Submitted by patient',
        confirmed: 'Confirmed',
        rejected: 'Rejected',
        verified: 'Verified',
      },
      clientDetail: {
        clientStatus: {
          title: 'Client status',
          subtitle: 'Quick readiness check. These hints never block work.',
          countsLabel: 'Client readiness summary',
          doneTitle: 'Completed',
          todoTitle: 'Needs attention',
          doneLabel: 'Done:',
          todoLabel: 'Next:',
          doneCount: 'Completed: {{count}}',
          todoCount: 'Left: {{count}}',
          loading: 'Checking client status…',
          unavailable: 'Treatment status could not be checked.',
          noneDone: 'No completed items yet.',
          nothingLeft: 'Everything needed now is ready.',
          items: {
            spacingMapReady: 'tooth spacing map uploaded.',
            spacingMapMissing: 'upload tooth spacing map.',
            activeTreatmentReady: 'active treatment created.',
            activeTreatmentMissing: 'create or activate treatment.',
            diagnosisReady: 'diagnosis added.',
            diagnosisMissing: 'add diagnosis to active treatment.',
            activeCycleReady: 'cycle {{number}} is active.',
            activeCycleMissing: 'create or activate treatment cycle.',
            completedStage: '“{{stage}}” step completed.',
            blockedStage: '“{{stage}}” step is blocked; check cause.',
            currentStage: '“{{stage}}” step is in progress.',
            requiredProcedureReady: 'required procedure “{{title}}” verified.',
            requiredProcedureNeedsVerification: 'verify completed procedure “{{title}}”.',
            requiredProcedurePending: 'complete required procedure “{{title}}”.',
            requiredProceduresMissing: 'configure required preparation procedures.',
            modelingPlanReady: 'treatment plan created.',
            modelingPlanMissing: 'create treatment plan.',
            publishedPlanReady: 'usable plan published for patient.',
            publishedPlanMissing: 'publish plan with aligner counts.',
            planApprovedByPatient: 'patient approved treatment plan.',
            planPendingPatientApproval: 'patient has not approved treatment plan yet.',
            paymentStageCurrent: 'payment is current step; check its status.',
            deliveryReady: 'delivery created.',
            deliveryMissing: 'create delivery for this cycle.',
            trackingReady: 'tracking number added.',
            trackingMissing: 'add tracking number before shipment.',
            deliveryShipped: 'order shipped.',
            deliveryDelivered: 'order delivered.',
            deliveryCancelled: 'delivery was cancelled; create or configure it again.',
            alignerSetsReady: 'aligner sets created: {{actual}} of {{expected}}.',
            alignerSetsMissing: 'create all aligner sets: {{actual}} of {{expected}}.',
            wearingStarted: 'aligner wearing started.',
            wearingNotStarted: 'record start of aligner wearing.',
          },
        },
        unableToLoadPatient: 'Unable to load patient',
        tryAgain: 'Try again in a moment.',
        backToClients: 'Back to clients',
        patientNotFound: 'Patient not found',
        hideTreatmentForm: 'Hide form',
        addTreatment: 'Add treatment',
        hideNotifications: 'Hide notifications',
        showNotifications: 'Show notifications',
        openChat: 'Open chat',
        workspaceNavigation: 'Patient workspace sections',
        treatments: 'Treatments',
        treatmentsSubtitle:
          'Manage the treatment summary, clinical links, cycle setup, and step progress here.',
        unableToLoadTreatments: 'Unable to load treatments.',
        noTreatmentsYet: 'No treatments yet.',
        noTreatmentsHint:
          'Create the first treatment to start tracking cycles and steps for this patient.',
        newTreatment: 'New treatment',
        newTreatmentHint:
          'First create a treatment summary, then add cycles and update steps below.',
        creatingTreatment: 'Creating treatment...',
        createTreatment: 'Create treatment',
        untitledTreatment: 'Untitled treatment',
        deleteTreatmentConfirm:
          'Delete treatment "{{name}}"? This cannot be undone.',
        deleteTreatmentTitle: 'Delete treatment',
        savingTreatment: 'Saving treatment...',
        saveTreatmentSummary: 'Save treatment summary',
        stages: 'Cycles',
        stageN: 'Cycle {{number}}',
        stagesCount_one: '{{count}} cycle',
        stagesCount_other: '{{count}} cycles',
        stageSelectorLabel: 'Cycle selector',
        correctionN: 'Correction {{number}}',
        renameStage: 'Change cycle name',
        renameStageLabel: 'Cycle name shown to the patient',
        cancelStageRename: 'Cancel the name change',
        stageLabelKind: {
          stage: 'Cycle',
          correction: 'Correction',
        },
        addingStage: 'Adding...',
        addStage: 'Add cycle',
        addStageBlockedByInProgress: 'Finish the current cycle first',
        deleteStageTitle: 'Delete cycle',
        deleteStageLabel: 'Delete {{label}}',
        deleteStageConfirm: 'Delete “{{label}}” and all its data? This cannot be undone.',
        deletingStage: 'Deleting...',
        noStagesYet:
          'No cycles yet. Add the first cycle to unlock step management.',
        treatmentStatus: 'Status',
        diagnosisTitle: 'Diagnosis title',
        diagnoses: 'Diagnoses',
        addDiagnosis: 'Add diagnosis',
        removeDiagnosis: 'Remove diagnosis',
        patientFeatures: 'Patient features',
        patientFeaturePlaceholder: 'Describe a feature',
        addPatientFeature: 'Add feature',
        removePatientFeature: 'Remove feature',
        recommendationLetter: 'Recommendation letter',
        recommendationLetterUploadCta: 'Upload recommendation letter',
        recommendationLetterReplaceCta: 'Replace',
        recommendationLetterDeleteCta: 'Delete',
        recommendationLetterDeleteConfirm:
          'Delete the recommendation letter? This cannot be undone.',
        recommendationLetterInvalidType:
          'Unsupported file type. Upload JPEG, PNG, or WebP.',
        recommendationLetterTooLarge: 'File exceeds the 10 MB size limit.',
        recommendationLetterPreviewLoadFailed: 'Could not load image.',
        recommendationLetterUploading: 'Uploading...',
        recommendationLetterDeleting: 'Deleting...',
        toothSpacingMap: 'Tooth spacing map',
        requiredBadge: 'Required',
        toothSpacingMapMissingTitle: 'Map not uploaded yet',
        toothSpacingMapMissingHint: 'Add JPEG, PNG, or WebP up to 10 MB.',
        toothSpacingMapUploadCta: 'Upload tooth spacing map',
        toothSpacingMapReplaceCta: 'Replace map',
        toothSpacingMapDeleteCta: 'Delete map',
        toothSpacingMapDeleteConfirm:
          'Delete the tooth spacing map? This cannot be undone.',
        toothSpacingMapInvalidType:
          'Unsupported file type. Upload JPEG, PNG, or WebP.',
        toothSpacingMapTooLarge: 'File exceeds the 10 MB size limit.',
        toothSpacingMapUploading: 'Uploading...',
        toothSpacingMapDeleting: 'Deleting...',
        toothSpacingMapPreviewLoadFailed: 'Could not load image.',
        currentStageKind: 'Current cycle',
        patientStageTitle: 'Patient-facing title',
        patientStageTitlePlaceholder: 'Optional title for the patient',
        upperAligners: 'Upper aligners',
        lowerAligners: 'Lower aligners',
        createdAt: 'Created {{datetime}}',
        sectionTreatmentsSubtitle: 'Diagnosis, cycles, stages',
        sectionTreatmentData: 'Treatment data',
        sectionTreatmentDataSubtitle: 'Status, diagnoses, patient features, and recommendation letters',
        sectionPhotoControl: 'Photo control',
        sectionPhotoControlSubtitle: 'Schedule and review patient photos',
        photoControl: {
          triggerSource: {
            wearingStageEntry: 'Auto · wearing start',
          },
          schedule: {
            title: 'Photo control schedule',
            subtitle: 'Automatic reminders for patient photos and videos',
            newSubtitle: 'Set the frequency and required materials',
            requiredPhotos: 'Required photos',
            selectPhoto: 'Select at least one photo',
            requireVideo: 'Require video',
          },
          review: {
            title: 'Photo control entries',
            subtitle: 'Review patient materials and leave recommendations',
            photoCount_one: '{{count}} photo',
            photoCount_other: '{{count}} photos',
            doctorComment: 'Doctor comment',
            noComment: 'No comment added',
            saveFailed: 'Could not save changes',
            viewVideo: 'Video viewer',
            closeVideo: 'Close video',
            viewPhotos: 'Photo viewer',
            closePhotos: 'Close viewer',
            previousPhoto: 'Previous photo',
            nextPhoto: 'Next photo',
          },
        },
        sectionToothSpacing: 'Tooth spacing',
        sectionToothSpacingSubtitle: 'Schedule and spacing entries',
        toothSpacing: {
          schedule: {
            title: 'Tooth spacing schedule',
            subtitle: 'Recurring tasks and reminders for the patient',
            newSubtitle: 'Set the procedure frequency',
          },
          review: {
            title: 'Tooth spacing entries',
            subtitle: 'Procedure history and patient materials',
          },
          entries: {
            title: 'Tooth spacing entries',
            subtitle: 'Quick overview of scheduled procedures',
          },
        },
        toothSpacingUi: {
          everyNDays: 'Every {{days}} days',
          filterByStatus: 'Filter entries by status',
          loadingEntries: 'Loading entries',
          loadEntriesFailed: 'Could not load entries',
          emptyEntries: 'No entries found',
          loadingDetails: 'Loading...',
          loadDetailsFailed: 'Could not load details',
          stageN: 'Cycle {{number}}',
          confirmedAt: 'Confirmed {{datetime}}',
          status: {
            all: 'All',
            pending: 'Pending',
            confirmed: 'Completed',
            active: 'Active',
            inactive: 'Inactive',
          },
          schedule: {
            title: 'Tooth spacing schedule',
            subtitle: 'Recurring tasks and reminders for the patient',
            treatment: 'Treatment',
            loading: 'Loading schedules',
            loadFailed: 'Could not load schedules',
            noEndDate: 'no end date',
            deactivate: 'Deactivate',
            empty: 'No schedules configured',
            newTitle: 'New schedule',
            newSubtitle: 'Set the procedure frequency',
            interval: 'Interval',
            startDate: 'Start date',
            endMode: 'Ends',
            endByDate: 'On a date',
            endByRepetitions: 'After a number of repetitions',
            endDateOptional: 'End date (optional)',
            datePlaceholder: 'dd.mm.yyyy',
            repetitions: 'Number of repetitions',
            creating: 'Creating...',
            create: 'Create schedule',
            createFailed: 'Could not create schedule. Try again.',
          },
          entries: {
            title: 'Tooth spacing entries',
            subtitle: 'Quick overview of scheduled procedures',
          },
          review: {
            title: 'Tooth spacing entries',
            subtitle: 'Procedure history and patient materials',
            video: 'Video',
            videoNotSubmitted: 'Video has not been submitted yet',
            description: 'Description',
            noDescription: 'No description added',
          },
        },
        monitoring: {
          filterByStatus: 'Filter entries by status',
          loadingEntries: 'Loading entries',
          loadEntriesFailed: 'Could not load entries',
          loadDetailsFailed: 'Could not load details',
          stageN: 'Cycle {{number}}',
          confirmedAt: 'Confirmed {{datetime}}',
          schedule: {
            loading: 'Loading schedules',
            loadFailed: 'Could not load schedules',
            active: 'Active',
            inactive: 'Inactive',
            noEndDate: 'no end date',
            newTitle: 'New schedule',
            interval: 'Interval',
            startDate: 'Start date',
            endMode: 'Ends',
            endByDate: 'On a date',
            endByRepetitions: 'After a number of repetitions',
            endDateOptional: 'End date (optional)',
            datePlaceholder: 'dd.mm.yyyy',
            repetitions: 'Number of repetitions',
            creating: 'Creating...',
            create: 'Create schedule',
            createFailed: 'Could not create schedule. Try again.',
          },
        },
        sectionAssignedAdmins: 'Assigned admins',
        sectionAssignedAdminsSubtitle:
          'Team members responsible for this patient',
        sectionPayments: 'Payments',
        sectionPaymentsSubtitle: 'Issue invoices and manage client payments',
        sectionPoints: 'Bonus points',
        sectionPointsSubtitle: "Grant and redeem this client's points",
        issueInvoice: 'Issue invoice',
        noPaymentsYet: 'No payments yet.',
        payments: {
          errorActiveCycle:
            'Patient must have exactly one active treatment cycle to issue an invoice.',
          errorExisting:
            'A non-confirmed payment already exists for this patient.',
          confirmCta: 'Confirm',
          rejectCta: 'Reject',
          rejectReasonPrompt: 'Enter rejection reason',
          cycleAutoSwitchHint:
            'Creating a payment auto-switches the active cycle to the payment stage. Confirming restores the cycle to its previous stage.',
          pointsBalanceHint:
            'This client has {{points}} bonus points ({{amount}} {{currency}}). Apply the discount to the invoice amount manually, then redeem the points in the Bonus points tab.',
          title: 'Invoice title',
          titlePlaceholder: 'e.g. Prepayment for treatment',
          untitledInvoice: 'Untitled invoice',
          bankAccount: 'Bank account',
          paymentMethod: 'Payment method',
          paymentMethodBank: 'Bank account',
          paymentMethodLink: 'Payment link',
          paymentMethodInvoicePdf: 'Payment by PDF invoice',
          invoicePdfMethodHint:
            'No requisites needed — the patient pays by the attached PDF invoice.',
          invoicePdfMethodNeedsFile:
            'Upload a PDF invoice from the payment card first, then switch the payment method.',
          invoiceFilePdf: 'PDF invoice',
          invoiceFilePdfHint: 'PDF only, up to 15 MB. Required for this payment method.',
          invoicePdfRequired: 'Attach a PDF invoice to create the payment.',
          invoicePdfOnly: 'Payment by PDF invoice accepts PDF files only.',
          paymentLink: 'Payment link',
          paymentLinkPlaceholder: 'https://...',
          paymentLinkRequired: 'Payment link is required',
          openPaymentLink: 'Open payment link',
          amount: 'Amount',
          currency: 'Currency',
          deadline: 'Deadline',
          createdAt: 'Created',
          rejectionReason: 'Rejection reason',
          selectBank: 'Select an account…',
          loading: 'Loading…',
          create: 'Create payment',
          creating: 'Creating…',
          recordPrepayment: 'Record prepayment',
          markPaidLabel: 'Record as already paid (prepayment)',
          markPaidHint:
            'Use when the patient paid outside the system. Does not change the cycle stage.',
          cancel: 'Cancel',
          edit: 'Edit',
          saveEdit: 'Save changes',
          invoiceFile: 'Invoice file',
          invoiceFileHint: 'PDF, Word, or Excel, up to 15 MB. Optional.',
          invoiceDropHint: 'Drag a file here, paste with Ctrl+V, or click to browse',
          invoiceNoFile: 'No file selected',
          invoiceRemoveFile: 'Remove file',
          uploadInvoice: 'Upload invoice file',
          replaceInvoice: 'Replace invoice',
          deleteInvoice: 'Delete invoice',
          viewInvoice: 'View invoice',
          invoiceWrongType: 'Please upload a PDF, Word, or Excel file.',
          invoiceTooLarge: 'File exceeds the 15 MB limit.',
          invoiceDeleteConfirm: 'Delete the invoice file?',
          uploadAfterCreateFailed:
            'Payment was created, but the file upload failed. Add it from the payment card.',
          deletePayment: 'Delete invoice',
          deletePaymentConfirm:
            'Delete this invoice? This action cannot be undone.',
          genericError: 'Could not complete the action. Please try again.',
        },
        assignedAdminsNone: 'No admins assigned yet.',
        assignedAdminsManage: 'Manage team',
        assignedAdminsClose: 'Close',
        assignedAdminsSave: 'Save',
        assignedAdminsCancel: 'Cancel',
        assignedAdminsSaving: 'Saving...',
        assignedAdminsSaveError: 'Failed to save assignments.',
        assignedAdminsRosterError: 'Failed to load admins.',
        assignedAdminsRosterLoading: 'Loading admins…',
        toggleTreatment: 'Toggle section',
        toggleStages: 'Toggle stages',
      },
      roles: {
        title: 'Roles & Permissions',
        subtitle: 'Access management',
        rolesTab: 'Roles',
        usersTab: 'Users',
        adminsTab: 'Admins',
        unableToLoadRoles: 'Unable to load roles',
        createRoleBtn: 'Create role',
        noRolesFound: 'No roles found',
        noRolesDescription: 'Create your first role to get started.',
        colName: 'Name',
        colDescription: 'Description',
        colPermissions: 'Permissions',
        colType: 'Type',
        colActions: 'Actions',
        permissionsCount: '{{count}} permissions',
        systemType: 'System',
        customType: 'Custom',
        editBtn: 'Edit',
        deleteBtn: 'Delete',
        deleteRoleConfirm: 'Delete role "{{name}}"?',
        editRoleTitle: 'Edit role: {{name}}',
        createRoleTitle: 'Create role',
        createRoleDescription: 'Define a new role with specific permissions.',
        editRoleDescription: 'Modify the role settings and permissions.',
        labelName: 'Name',
        labelDescription: 'Description',
        labelPermissions: 'Permissions',
        cancel: 'Cancel',
        close: 'Close',
        saving: 'Saving...',
        create: 'Create',
        save: 'Save',
        unableToLoadUsers: 'Unable to load users',
        noUsersFound: 'No users found',
        noUsersDescription: 'Users will appear here once created.',
        colEmail: 'Email',
        colRoles: 'Roles',
        noRolesAssigned: 'No roles',
        assign: 'Assign',
        assignRolesTitle: 'Assign roles',
        assignRolesSubtitle: 'Select roles for {{name}}',
        inviteAdminBtn: 'Invite admin',
        inviteAdminTitle: 'Invite admin',
        inviteAdminDescription:
          'Send an email invitation. The recipient will get a 4-digit code to activate their account.',
        editAdminTitle: 'Edit admin',
        editAdminDescription: 'Update name and assigned roles.',
        deleteAdminConfirm:
          'Delete admin "{{name}}"? This action cannot be undone.',
        labelFirstName: 'First name',
        labelLastName: 'Last name',
        labelEmail: 'Email',
        labelFullName: 'Full name',
        inviteSentMessage:
          'Invitation sent. The user will receive an email with the code.',
        invite: 'Invite',
        acceptInviteTitle: 'Accept invitation',
        acceptInviteSubtitle:
          'Enter the code from your email and choose a password to sign in.',
        acceptInviteCode: 'Verification code',
        acceptInvitePassword: 'New password',
        acceptInvitePasswordConfirm: 'Confirm password',
        acceptInviteSubmit: 'Activate account',
        acceptInviteSuccess: 'Account activated. Redirecting…',
        acceptInviteError:
          'Failed to accept invitation. Check the code and try again.',
        passwordMismatch: 'Passwords do not match.',
        resetPasswordBtn: 'Reset password',
        resetPasswordTitle: 'Send password reset?',
        resetPasswordConfirm:
          'Send {{name}} a password reset email at {{email}}?',
        resetPasswordSending: 'Sending...',
        resetPasswordSent: 'Password reset email sent to {{email}}.',
        resetPasswordError: 'Failed to send password reset email.',
      },
      helpArticles: {
        forbidden: 'Access denied',
        forbiddenDescription:
          'You do not have permission to manage help articles.',
        title: 'Blog',
        subtitleCount_one: '{{count}} article in the library',
        subtitleCount_other: '{{count}} articles in the library',
        newArticle: 'New article',
        mobileAppPreview: 'Mobile preview',
        mobileAppPreviewTitle: 'Mobile blog preview',
        mobileAppPreviewListHint:
          'The list shows published articles only, exactly as patients see it.',
        mobileAppPreviewDraftHint: 'Preview includes unsaved changes from the editor.',
        closeMobileAppPreview: 'Close preview',
        previewArticle: 'Preview article',
        untitledPreview: 'Untitled article',
        searchPlaceholder: 'Search articles...',
        library: 'Library',
        itemsCount: '{{count}} items',
        loadingArticles: 'Loading articles…',
        unableToLoad: 'Unable to load articles',
        tryAgain: 'Try again in a moment.',
        noArticlesFound: 'No articles found',
        noArticlesDescription: 'Adjust the search or create the first article.',
        orderLabel: 'Order {{order}}',
        createArticle: 'Create article',
        selectArticle: 'Select article',
        draftHint: 'Drafts are hidden in the mobile app until published.',
        moveToDraft: 'Move to draft',
        publish: 'Publish',
        noArticleSelected: 'No article selected',
        noArticleSelectedDescription:
          'Select an article from the library or create a new one.',
        titleLabel: 'Title',
        summaryLabel: 'Summary',
        sortOrderLabel: 'Sort order',
        mobilePreviewTitle: 'Mobile card preview',
        mobilePreviewDescription:
          'Set a dedicated image and crop for the article card in the mobile app.',
        mobilePreviewAlt: 'Article card preview',
        mobilePreviewEmpty: 'Add a cover image or a dedicated card image.',
        mobilePreviewLoadError: 'Could not load or display the image.',
        previewDedicatedHint: 'The mobile app will use the dedicated image.',
        previewHeroFallbackHint:
          'No dedicated image. The mobile app will fall back to the cover image.',
        previewNoFallbackHint: 'No dedicated or cover image. The card will have no image.',
        uploadPreviewImage: 'Upload card image',
        replacePreviewImage: 'Replace card image',
        removePreviewImage: 'Remove card image',
        previewImageFormats:
          'JPEG, PNG, or WebP · maximum 10 MB · up to 2048 px per side and 4 MP.',
        previewFitLabel: 'Image fit',
        previewFitCover: 'Crop to fill',
        previewFitContain: 'Show full image',
        previewPositionX: 'Horizontal position',
        previewPositionY: 'Vertical position',
        heroImage: 'Cover image',
        imageUploaded: 'Image uploaded',
        noImageUploaded: 'No image uploaded yet',
        uploadImage: 'Upload image',
        heroImagePendingHint: 'It will upload when you save this draft.',
        clearPendingHero: 'Remove file',
        mediaTabImage: 'Image',
        mediaTabVideo: 'Video',
        mediaTabYoutube: 'YouTube',
        uploadVideo: 'Upload video',
        videoUploaded: 'Video uploaded',
        noVideoUploaded: 'No video uploaded yet',
        videoPendingHint: 'Video will upload when you create the draft.',
        clearPendingVideo: 'Remove pending video',
        mediaTabPdf: 'PDF',
        heroPdf: 'PDF document',
        uploadPdf: 'Upload PDF',
        pdfUploaded: 'PDF uploaded (mobile shows the first page as the cover)',
        noPdfUploaded: 'No PDF uploaded yet',
        pdfPendingHint: 'PDF will upload when you create the draft.',
        clearPendingPdf: 'Remove pending PDF',
        uploadingPdf: 'Uploading PDF…',
        pdfRequirements: 'PDF only · maximum {{maxMb}} MB.',
        pdfTooLarge: 'PDF cannot exceed {{maxMb}} MB. Compress the file and try again.',
        pdfPreviewLabel: 'PDF preview',
        pdfPreviewError: 'Could not load the PDF',
        youtubeUrlLabel: 'YouTube URL',
        youtubeUrlPlaceholder: 'https://youtube.com/watch?v=...',
        invalidYoutubeUrl: 'Invalid YouTube URL.',
        saveYoutube: 'Save YouTube link',
        youtubePosterAuto: 'Thumbnail auto-fetched from YouTube.',
        removeMedia: 'Remove media',
        sections: 'Sections',
        addSection: 'Add section',
        sectionHeading: 'Heading',
        sectionBody: 'Body',
        removeSection: 'Remove section',
        saveChanges: 'Save changes',
        createDraft: 'Create draft',
        deleteArticle: 'Delete article',
        deleteArticleConfirm: 'Delete article "{{title}}"? This action cannot be undone.',
        statusPublished: 'published',
        statusDraft: 'draft',
      },
      chats: {
        inbox: 'Inbox',
        assignedChats: 'Assigned chats',
        chatActions: 'Chat actions for {{name}}',
        markUnread: 'Mark as unread',
        searchPlaceholder: 'Search patient or admin',
        searchMessages: 'Search in conversation',
        searchMessagesTitle: 'Search messages',
        searchNoResults: 'No matches found',
        searchPrev: 'Previous match',
        searchNext: 'Next match',
        closeSearch: 'Close search',
        jumpToLatest: 'Jump to latest',
        jumpToDate: 'Jump to date',
        selectDate: 'Select a date',
        today: 'Today',
        yesterday: 'Yesterday',
        unlabelledPatient: 'Unlabelled patient',
        selectChat: 'Select a chat to open the conversation.',
        loadingConversation: 'Loading conversation…',
        noConversation: 'No conversation for this patient.',
        patientThread: 'Patient thread',
        noPatientId: 'No patient ID',
        assignedAdminsCount: '{{count}} assigned admins',
        openPatientProfile: 'Open patient profile',
        patientProfileTitle: 'Patient profile',
        closeTeamAssignment: 'Close team assignment',
        manageAssignedTeam: 'Manage assigned team',
        backToList: 'Back to list',
        close: 'Close',
        manageTeam: 'Manage team',
        assignedAdminsTitle: 'Assigned admins',
        available: 'Available now',
        offline: 'Offline',
        cancel: 'Cancel',
        saveAssignments: 'Save assignments',
        fileAttachmentReady: 'File attachment ready',
        discardAttachment: 'Discard attachment',
        sendFile: 'Send file',
        discard: 'Discard',
        send: 'Send',
        recordingVoice: 'Recording voice message · {{time}}',
        messagePlaceholder: 'Message',
        attachFile: 'Attach file',
        dropFileHere: 'Drop file to attach',
        stopRecording: 'Stop recording',
        sendMessage: 'Send message',
        chooseEmoji: 'Choose emoji',
        insertEmoji: 'Insert emoji',
        reactToMessage: 'React to message',
        chooseReaction: 'Choose reaction',
        reactWith: 'React with',
        addReaction: 'Add reaction',
        removeReaction: 'Remove reaction',
        reactionFailed: 'Could not update reaction. Try again.',
        recordVoice: 'Record voice message',
        voiceMessage: 'Voice message',
        deleteVoiceMessage: 'Delete voice message',
        pausePreview: 'Pause',
        playPreview: 'Play',
        sendVoiceMessage: 'Send voice message',
        micNotAvailable:
          'Microphone recording is not available in this browser.',
        noAudioCaptured: 'No audio was captured.',
        recordingStopped: 'Recording stopped unexpectedly.',
        micPermissionDenied: 'Microphone permission denied or unavailable.',
        voicePlaybackRequiresSession:
          'Voice playback requires an active admin session.',
        voicePlaybackUnavailable: 'Voice playback is unavailable.',
        voiceLoading: 'Loading…',
        demoVoiceMock: 'Demo voice — mock mode',
        voiceMessageFallback: 'Voice message',
        fileAttachmentFallback: 'File attachment',
        mockFileAttachment: 'Mock file attachment.',
        fileDownloadUnavailable: 'File download unavailable.',
        unknownFileType: 'Unknown file type',
        downloading: 'Downloading',
        downloadFile: 'Download file',
        downloadingEllipsis: 'Downloading…',
        download: 'Download',
        openImage: 'Open image',
        noActivity: 'No activity',
        pauseVoiceMessage: 'Pause voice message',
        playVoiceMessage: 'Play voice message',
        patientTyping: 'Patient is typing…',
        messageActions: 'Message actions',
        editMessage: 'Edit',
        deleteMessage: 'Delete',
        editedSuffix: 'edited',
        saveEdit: 'Save',
        cancelEdit: 'Cancel',
        editMessagePlaceholder: 'Edit message',
        confirmDeleteMessage: 'Delete this message?',
        seekVoiceMessage: 'Seek voice message',
        playbackSpeed: 'Playback speed',
        adminAvatarAlt: 'Avatar of {{name}}',
      },
      patientProfile: {
        active: 'Active',
        inactive: 'Inactive',
        emailLabel: 'Email',
        notRegisteredYet:
          'Not registered yet — share the invite code with the patient',
        birthDateLabel: 'Birth date',
        genderLabel: 'Gender',
        genderMale: 'Male',
        genderFemale: 'Female',
        genderOther: 'Other',
        leadIdLabel: 'Lead ID',
        leadIdPlaceholder: 'Add Lead ID',
        leadIdEmpty: 'Not set',
        leadIdSave: 'Save',
        leadIdCancel: 'Cancel',
        leadIdEdit: 'Edit',
        leadIdSaveFailed: 'Failed to save Lead ID',
      },
      preparing: {
        title: 'Procedures',
        subtitle:
          'Manage preparatory procedures for this cycle. Patients see them as a checklist.',
        optional: 'optional',
        completedSummary: '{{done}} / {{total}} done',
        addSectionTitle: 'New procedure',
        noProceduresHint: 'Add a procedure below — the patient sees it in their checklist.',
        statusPending: 'Pending',
        statusCompleted: 'Completed',
        statusVerified: 'Verified',
        markComplete: 'Mark complete',
        verify: 'Verify',
        remove: 'Remove',
        edit: 'Edit',
        save: 'Save',
        cancel: 'Cancel',
        saving: 'Saving...',
        dragHandle: 'Reorder',
        noProcedures: 'No procedures added yet.',
        procedureTitleLabel: 'Procedure title',
        procedureTitlePlaceholder: 'e.g. Panoramic X-ray',
        descriptionLabel: 'Description (optional)',
        descriptionPlaceholder: 'Procedure details...',
        required: 'Required',
        yes: 'Yes',
        no: 'No',
        adding: 'Adding...',
        addProcedure: 'Add procedure',
      },
      modeling: {
        title: 'Modeling',
        subtitle:
          'Set the aligner counts per jaw and upload visualization media.',
        upperJaw: 'Upper jaw aligners',
        lowerJaw: 'Lower jaw aligners',
        saving: 'Saving...',
        saveAlignerCounts: 'Save aligner counts',
        saveSettings: 'Save settings',
        visualizationTitle: 'Visualization title',
        visualizationTitlePlaceholder: 'e.g. Tooth movement video',
        visualizationDescription: 'Visualization description',
        visualizationDescriptionPlaceholder:
          'Short description shown to patient',
        visualizationMedia: 'Visualization media',
        mediaCountSummary: '{{videos}} video • {{photos}} photos',
        addMedia: 'Add media',
        deleteMedia: 'Delete',
        mediaPhoto: 'Photo',
        mediaVideo: 'Video',
        videoLimitReached: 'Only one video can be uploaded.',
        photoLimitReached: 'No more than 10 photos can be uploaded.',
        dragToReorder: 'Drag to reorder',
        confirmDelete: 'Delete this file?',
        status: 'Status',
        dropOrBrowse: 'Drag and drop here, or click to browse (video + photos)',
        uploading: 'Uploading...',
        treatmentDescription: 'Treatment description',
        treatmentDescriptionPlaceholder:
          'Detailed plan, composite attachments, multi-stage notes...',
        pricingSection: 'Treatment pricing',
        estimatedDays: 'Estimated duration (days)',
        alignerUnitPrice: 'Price per aligner',
        prepayment: 'Prepayment (subtracted)',
        discount: 'Discount (subtracted)',
        pricingCurrency: 'Currency',
        additionalItems: 'Additional items',
        additionalItemName: 'Name',
        additionalItemPrice: 'Price',
        addAdditionalItem: '+ Add item',
        removeAdditionalItem: 'Remove',
        pricingTotal: 'Total due',
        pricingPreview: 'Patient preview',
        planSection: 'Treatment plan',
        summaryAligners: 'Aligners ({{qty}} pcs)',
        summaryExtras: 'Additional items',
        planApprovedByPatient: 'Patient approved the treatment plan',
        planApprovedAt: 'Approved',
        planPendingApproval: 'Patient has not approved the treatment plan yet',
        pricingSharedHint:
          'These values are shared by every plan in this cycle. Aligner counts and additional items are set per plan below.',
        visualizationHint: 'The caption the patient sees above the visualization media.',
        tabsLabel: 'Modeling step sections',
        tabPlans: 'Plans',
        tabSettings: 'Shared settings',
        tabMedia: 'Media',
        unsavedChanges: 'Unsaved changes',
        selectedPlanLabel: 'Chosen plan',
        noSelectedPlan: 'No plan chosen yet',
      },
      planOptions: {
        title: 'Treatment plans',
        subtitle:
          'The main plan and its alternatives. The patient only sees published plans and picks one of them.',
        empty: 'No plans yet. Add the main plan so the patient sees an offer.',
        addMain: '+ Add main plan',
        addAlternative: '+ Add alternative plan',
        mainPlanTitle: 'Main plan',
        alternativePlanTitle: 'Alternative plan {{index}}',
        mainBadge: 'Main',
        selectedBadge: 'Chosen by patient',
        published: 'Published',
        unpublished: 'Draft',
        showToPatient: 'Show to patient',
        selectForPatient: 'Choose for patient',
        selectNeedsCounts: 'Set the aligner counts first',
        resetSelection: 'Reset selection',
        confirmDelete: 'Delete the plan "{{title}}" together with its 3D models?',
        planTitle: 'Plan title',
        sectionIdentity: 'Plan',
        clinicalComment: 'Doctor comment',
        clinicalCommentHint: 'Clinical plan description — required',
        clinicalCommentPlaceholder:
          'Describe the clinical plan, key points, and recommendations for the patient…',
        wholeCourse: 'Whole alignment course',
        wholeCourseHint: 'Course parameters do not affect the current-stage price.',
        estimatedStages: 'Estimated stages',
        maxCourseAligners: 'Maximum aligners for full course',
        currentStage: 'Current stage',
        currentStageHint: 'Duration is calculated automatically and can be overridden.',
        setupAligners: 'Setup aligners (optional)',
        daysPerAligner: 'Days per aligner (default 10)',
        durationOverride: 'Duration override (auto: {{days}} days)',
        stageDerived:
          'Manufactured this stage: {{manufactured}} · Duration: {{duration}} days · Setup aligners affect manufacturing and price, but not duration.',
        alignerPricing: 'Aligner pricing',
        alignerPricingHint: 'Quantity always comes from the clinical fields above; set price here.',
        pricingMode: 'Aligner pricing mode',
        pricingAuto: 'Auto',
        pricingCustom: 'Custom',
        regularAligner: 'Regular',
        customAligner: 'Custom',
        autoPricingLine: 'Regular · {{manufactured}} pcs',
        unitPrice: 'Unit price, {{currency}}',
        itemType: 'Type',
        alignerJaw: 'Jaw',
        alignerJawUpper: 'Upper',
        alignerJawLower: 'Lower',
        alignerJawNone: 'Not assigned',
        alignerKind: 'Aligner type',
        alignerKind_REGULAR: 'Regular',
        alignerKind_WITH_OVERLAYS: 'With overlays',
        alignerKind_SETUP: 'Setup aligner',
        alignerKind_RETENTION_CAP: 'Retention cap',
        alignerKind_CUSTOM: 'Other type',
        customAlignerName: 'Other type name',
        quantity: 'Quantity',
        allocationOk:
          'Treatment aligners: {{allocated}} of {{manufactured}} · Retention caps: {{retention}}.',
        allocationMismatch:
          'Treatment aligners: {{allocated}} of {{manufactured}} — fix the quantity. Retention caps: {{retention}}.',
        addAlignerItem: '+ Add product',
        removeAlignerItem: 'Remove product',
        structuredElements: 'Additional elements',
        structuredElementsHint: 'Enable only relevant blocks; disabled blocks stay hidden from patient.',
        attachments: 'Attachments',
        optionalQuantity: 'Quantity (optional)',
        doctorComment: 'Doctor comment',
        buttons: 'Buttons',
        elastics: 'Elastics',
        sets: 'Number of sets',
        separation: 'Separation required',
        price: 'Price, {{currency}}',
        typeComment: 'Type / comment',
        otherClinicalElements: 'Other clinical elements',
        addClinicalElement: '+ Add clinical element',
        elementTitle: 'Title',
        elementDescription: 'Description',
        paid: 'Paid',
        removeClinicalElement: 'Remove clinical element',
        schemeImage: 'Scheme image',
        schemeImages: 'Scheme images',
        schemeUpload: 'Add images',
        schemeReplace: 'Replace',
        schemeDelete: 'Delete',
        schemeUploading: 'Uploading…',
        schemeRequirements: 'JPEG, PNG, or WebP · up to 10 MB',
        schemeSaveFirst: 'Save plan changes first.',
        schemeInvalidType: 'Choose a JPEG, PNG, or WebP image.',
        schemeInvalidSize: 'Image must be no larger than 10 MB.',
        schemeTooMany: 'You can add up to {{max}} images per element.',
        schemeLimitReached: 'Maximum added: {{max}}',
        schemePreviewAltNumbered: '{{label}} — image {{number}}',
        schemeUntitled: 'Untitled image',
        schemePreviewAlt: 'Scheme: {{label}}',
        schemePreviewLoading: 'Loading image…',
        schemePreviewError: 'Image could not be loaded.',
        depositDiscounts: 'Deposit & discounts',
        depositAmount: 'Deposit amount, {{currency}}',
        discountsPromotions: 'Discounts / promotions',
        addDiscount: '+ Add discount / promotion',
        discountName: 'Name',
        discountComment: 'Comment',
        discountAmount: 'Amount, {{currency}}',
        removeDiscount: 'Remove discount',
        keyDifference: 'Key difference between plans',
        keyDifferencePlaceholder: 'How this plan differs from the main plan…',
        currencyUah: 'UAH',
        validationFix: 'Fix plan errors before saving.',
        publishNeedsSavedValid: 'Save a valid plan first.',
        selectNeedsPublished: 'Publish the plan first.',
        validation_clinical_comment_required: 'Add the doctor comment.',
        validation_custom_quantity_mismatch:
          'Custom aligner allocation must equal the clinical quantity.',
        validation_integer_invalid: 'Counts must be whole numbers without decimals or exponents.',
        validation_value_out_of_range: 'One or more values exceed the allowed range.',
        validation_money_invalid: 'Money must be non-negative with at most two decimal places.',
        validation_text_too_long: 'Shorten text to the allowed length.',
        validation_list_too_long: 'One of the lists contains too many items.',
        validation_required_label: 'Complete the names of all added items.',
        upperJaw: 'Upper jaw (aligners)',
        lowerJaw: 'Lower jaw (aligners)',
        summaryAligners: 'Aligners ({{qty}} pcs)',
        summaryExtras: 'Additional items',
        summaryDiscount: 'Discount',
        summaryPrepayment: 'Prepayment',
        summaryDeposit: 'Deposit',
        pricingTotal: 'Total due',
        pricingPreview: 'Patient breakdown',
        pricingUnavailable: 'Set the price per aligner under "Treatment pricing" to see the total.',
        savePlan: 'Save plan',
        saving: 'Saving…',
        meshSection: '3D models (STL)',
        view3d: 'View in 3D',
        jaw_upper: 'Upper',
        jaw_lower: 'Lower',
        role_current: 'Current',
        role_result: 'Result',
        meshUpload: 'Upload STL',
        meshReplace: 'Replace',
        meshDelete: 'Delete',
        meshUntitledFile: 'Untitled file',
        meshStatusEmpty: 'No file',
        meshStatusPending: 'Queued',
        meshStatusProcessing: 'Processing…',
        meshStatusReady: 'Ready',
        meshStatusFailed: 'Failed',
        viewerLoadFailed: 'The model could not be loaded.',
        viewerSourceFallback:
          'Showing the source STL — the optimised version is still being generated, so loading may be slow.',
        viewerPreviewPending_one:
          '{{count}} more model is still being prepared — it will appear once the server finishes.',
        viewerPreviewPending_other:
          '{{count}} more models are still being prepared — they will appear once the server finishes.',
        meshReprocess: 'Retry processing',
        meshStalled: 'Processing is taking longer than expected. Try again.',
        unsavedChanges: 'Unsaved changes',
        unsavedHint: 'Changes are not saved yet',
        plansNavLabel: 'Plan list',
        railCounts: '{{upper}} / {{lower}} aligners',
        railMeshes: '{{ready}}/{{total}} STL',
        railNoPrice: 'Not priced',
      },
      movementSteps: {
        title: 'Tooth movement',
        subtitle:
          'Ordered steps (0…N) per jaw. The patient reviews them during payment and delivery.',
        empty: 'No steps yet. Add the first step and upload an STL.',
        addStep: '+ Add step',
        deleteStep: 'Delete step',
        stepLabel: 'Step {{index}}',
        confirmDeleteStep: 'Delete step {{index}} together with its 3D models?',
      },
      delivery: {
        title: 'Delivery',
        subtitle: 'The patient saves the address in the app. Create the shipment, then add the TTH.',
        addressCardTitle: 'Address',
        shipment: 'Shipment',
        notCreated: 'Not created',
        shippedAt: 'Shipped',
        deliveredAt: 'Delivered',
        receivedAt: 'Patient confirmed receipt',
        save: 'Save',
        patientDeliveryDetails: 'Patient delivery details',
        loadingAddresses: 'Loading addresses…',
        noDeliveryAddress:
          'No delivery address on file yet. The patient can add one from the app during the delivery step.',
        addressId: 'Address ID',
        shipTo: 'Ship to',
        selectAddress: 'Select address…',
        createDelivery: 'Create Delivery',
        deliveryStatus: 'Status',
        tracking: 'Tracking',
        consignmentNote: 'Consignment Note',
        trackingNumber: 'Tracking number (TTH)',
        enterTTH: 'Enter TTH number',
        saveTrackingNumber: 'Save Tracking Number',
        confirmPatientReceived: 'Confirm Patient Received',
        deliveryManagement: 'Delivery Management',
        createDeliverySection: 'Create Delivery',
        deliveryAddressId: 'Delivery address ID',
        addressIdPlaceholder: 'Address ID',
        updateTracking: 'Update Tracking',
        tthPlaceholder: 'TTH number',
        method: {
          novaPoshta: 'Nova Poshta',
          ukrposhta: 'Ukrposhta',
          international: 'International',
        },
      },
      wearing: {
        title: 'Aligner Sets',
        subtitle:
          'The patient manages wearing from the mobile app. Counts per jaw can be changed until they start wearing.',
        upper: 'Upper',
        lower: 'Lower',
        aligners: 'aligners',
        started: 'Wearing since',
        alignerCountChip: '{{total}} aligners',
        estimatedWear: '≈ {{days}} days of wear',
        progressTitle: 'Wearing progress',
        upperJaw: 'Upper jaw',
        lowerJaw: 'Lower jaw',
        numberOfAligners: 'Number of aligners',
        daysPerAligner: 'Days per aligner',
        currentCount: 'Current: {{count}}',
        notConfigured: 'Not configured',
        creating: 'Saving…',
        createSets: 'Create',
        updateSets: 'Replace',
        savedJustNow: '✓ Saved',
        cannotEditStarted:
          'Patient has already started wearing — count cannot be changed.',
        sameValueHint: 'Change the count to save.',
        progress: {
          upperHeader: 'Upper jaw — progress',
          lowerHeader: 'Lower jaw — progress',
          summaryActive: 'Current #{{number}}',
          summaryIdle: '{{total}} aligners',
          alignerLabel: 'Aligner {{number}}',
          statusNotStarted: 'Not started',
          statusWearing: 'Wearing',
          statusPaused: 'Paused',
          statusCompleted: 'Completed',
          daysWornOfTarget: '{{worn}} / {{target}} days',
          daysHoursWorn: '{{days}}d {{hours}}h',
          edit: 'Edit',
          save: 'Save',
          cancel: 'Cancel',
          editTitle: 'Wear correction',
          statusField: 'Status',
          editAlignerN: 'Edit aligner {{number}}',
          daysInput: 'Days',
          hoursInput: 'Hours',
          saveError: 'Failed to save. Please try again.',
          saved: 'Saved',
          targetExceededWarning:
            'Entered time exceeds the aligner target duration.',
          noAlignersHint: 'Aligner sets have not been created yet.',
        },
      },
      stageEditor: {
        stageN: 'Cycle {{number}}',
        saving: 'Saving…',
        failedToSave: 'Failed to save',
        finishing: 'Finishing...',
        finishStage: 'Finish stage',
        failedToFinish: 'Failed to finish',
        changeStage: 'Change stage',
        changeStageTitle: 'Change current stage',
        changeStageHint:
          'This stage is visible to the patient in the mobile app. Confirm to apply.',
        confirmChange: 'Confirm',
        cancel: 'Cancel',
        deleteStage: 'Delete stage',
        preparing: 'Preparing',
        modeling: 'Modeling',
        payment: 'Payment',
        delivery: 'Delivery',
        wearing: 'Wearing',
        paymentMovedNotice:
          'Payments are now managed from the Payments section on the client detail page.',
        paymentOpenSection: 'Open Payments section',
        upper: 'Upper',
        lower: 'Lower',
        noTreatmentsYet: 'No treatments yet.',
        untitledTreatment: 'Untitled treatment',
        stages: 'Stages',
        created: 'Created',
        finishCycle: 'Finish cycle',
        finishingCycle: 'Finishing...',
        finishCycleConfirm: 'Finish cycle?',
        finishCycleRequiresNext:
          'Create the next cycle to finish this one manually. The final cycle completes automatically after wearing all aligners.',
        resumeCycle: 'Resume cycle',
        resumingCycle: 'Resuming...',
        activateCycle: 'Activate cycle',
        activatingCycle: 'Activating...',
        cancelCycle: 'Cancel cycle',
        cancellingCycle: 'Cancelling...',
        cancelCycleConfirm: 'Cancel cycle?',
        cycleStatus: {
          draft: 'Draft',
          in_progress: 'In progress',
          completed: 'Completed',
          cancelled: 'Cancelled',
        },
        patientBannerLabel: 'Patient currently sees',
        patientBannerHint:
          'When this step is finished, move the patient to the next one so the mobile app updates.',
        movePatientTo: 'Move patient to…',
        movePatientHere: 'Move patient here',
        movePatientConfirm:
          'Move the patient to “{{stage}}”? This updates the current step in the mobile app.',
        patientRemainsAt: 'Patient remains on “{{stage}}”.',
        patientTabBadge: 'Patient view',
        adminViewBadge: 'Your view',
        patientAtThisStage: 'Patient is here',
        toggleStage: 'Toggle stage',
      },
      alignerPanel: {
        title: 'Aligner Sets',
        upper: 'Upper',
        lower: 'Lower',
        aligners: 'aligners',
        createTitle: 'Create aligner sets',
        createHint:
          'Bulk-create once per jaw per cycle. If sets already exist for the selected jaw, creation is rejected — use the other jaw or delete the existing sets first.',
        jaw: 'Jaw',
        upperJaw: 'Upper',
        lowerJaw: 'Lower',
        numberOfAligners: 'Number of aligners',
        daysPerAligner: 'Days per aligner',
        creating: 'Creating...',
        createSets: 'Create sets',
      },
      cyclePayment: {
        title: 'Payment Management',
        createPaymentTitle: 'Create Payment',
        bankAccountId: 'Bank account ID',
        bankAccountIdPlaceholder: 'Bank account ID',
        amount: 'Amount',
        currency: 'Currency',
        deadline: 'Payment deadline',
        createBtn: 'Create payment',
      },
      photoSchedule: {
        everyNDays: 'Every {{days}} days',
      },
      profile: {
        title: 'My profile',
        avatarSection: 'Profile photo',
        personalInfoSection: 'Personal information',
        passwordSection: 'Change password',
        fullName: 'Full name',
        firstName: 'First name',
        lastName: 'Last name',
        phoneNumber: 'Phone',
        telegramUsername: 'Telegram',
        telegramHelp: 'Without @, e.g. white_and_flex',
        optionalPlaceholder: 'Optional',
        currentPassword: 'Current password',
        newPassword: 'New password',
        confirmNewPassword: 'Confirm new password',
        changePhoto: 'Change photo',
        removePhoto: 'Remove photo',
        uploading: 'Uploading…',
        removing: 'Removing…',
        savePersonal: 'Save changes',
        saving: 'Saving…',
        changePassword: 'Change password',
        saveSuccess: 'Changes saved.',
        passwordSuccess: 'Password updated successfully.',
        passwordMismatch: 'New password and confirmation do not match.',
        passwordTooShort:
          'Password must contain at least {{count}} characters.',
        avatarTooLarge: 'File exceeds 5 MB.',
        avatarInvalidType: 'Allowed formats: PNG, JPEG, WebP.',
        avatarUploadError: 'Failed to upload photo',
        removeConfirm: 'Remove your current profile photo?',
      },
    },
  },
} as const;
